{
  "shared": {
    "filters": {
      "search": "Search...",
      "freight_method": "Freight method",
      "status": "Status",
      "organization_one": "Organization",
      "organization_other": "Organizations",
      "country_one": "Country",
      "country_other": "Countries",
      "watched_by": "Watched by",
      "sort": "Sort",
      "cta_reset_filters": "Reset filters",
      "anyone": "Anyone",
      "no_one": "No one",
      "newest_first": "Newest first",
      "oldest_first": "Oldest first",
      "company_name_a_to_z": "Company name (A-Z)",
      "company_name_z_to_a": "Company name (Z-A)",
      "import_export": "Import/Export",
      "validity": "Validity",
      "exceptions": "Exceptions",
      "activity": "Activity",
      "departure": "Departure",
      "arrival": "Arrival",
      "pickup": "Pick-up",
      "delivery": "Delivery"
    },
    "order_status": {
      "sent": "Sent",
      "received": "Received",
      "in_progress": "In progress",
      "completed": "Completed",
      "canceled": "Canceled"
    },
    "cta_create_booking": "Create Booking",
    "cta_request_quote": "Request Quote",
    "cta_view_spot_rate": "View Quote",
    "cta_view_shipment": "View Shipment",
    "cta_view_booking": "View Booking",
    "cta_view_request": "View Request",
    "cta_view_all": "View All",
    "cta_view": "View",
    "cta_edit": "Edit",
    "cta_delete": "Delete",
    "cta_remove": "Remove",
    "cta_save": "Save",
    "cta_cancel": "Cancel",
    "cta_confirm": "Confirm",
    "cta_close": "Close",
    "cta_submit": "Submit",
    "cta_continue": "Continue",
    "cta_next": "Next",
    "cta_back": "Back",
    "cta_send": "Send",
    "cta_reset": "Reset",
    "txt_dashboard": "Dashboard",
    "txt_quotes": "Requests & Quotes",
    "txt_quote_request_one": "Quote request",
    "txt_quote_request_other": "Quote requests",
    "txt_spot_rate_one": "Quote",
    "txt_spot_rate_other": "Quotes",
    "txt_contract_one": "Contract",
    "txt_contract_other": "Contracts",
    "txt_booking_one": "Booking",
    "txt_booking_other": "Bookings",
    "txt_shipment_one": "Shipment",
    "txt_shipment_other": "Shipments",
    "txt_invoice_one": "Invoice",
    "txt_invoice_other": "Invoices",
    "txt_address_book": "Address book",
    "txt_reporting": "Reporting",
    "txt_organization_one": "Organization",
    "txt_organization_other": "Organizations",
    "txt_what's_new?": "What's new?",
    "txt_calendar": "Calendar",
    "txt_general": "General",
    "txt_incoterm": "Incoterm",
    "txt_incoterm_place": "Incoterm Place",
    "txt_bill_of_lading": "Bill of Lading",
    "alert_confirm_bill_of_lading": "I confirm, the Bill of Lading provided is correct and applies to all cargo in this booking.",
    "txt_routing": "Routing",
    "txt_service": "Service",
    "txt_container": "Container",
    "txt_containers": "Containers",
    "txt_quantity": "Quantity",
    "txt_type": "Type",
    "txt_cargo_details": "Cargo Details",
    "txt_weight": "Weight",
    "txt_packages": "Packages",
    "txt_weight_per_piece": "Weight per piece",
    "txt_total_weight": "Total weight",
    "txt_length_per_piece": "Length per piece",
    "txt_width_per_piece": "Width per piece",
    "txt_height_per_piece": "Height per piece",
    "txt_volume_per_piece": "Volume per piece",
    "txt_total_volume": "Total Volume",
    "txt_dimensions_per_piece": "Dimensions per piece",
    "txt_dangerous_goods": "Dangerous goods",
    "txt_total": "total",
    "txt_product_ready_date": "Product ready date",
    "txt_anticipated_delivery_date": "Anticipated delivery date",
    "txt_goods_description": "Goods description",
    "txt_attachments": "Attachments",
    "txt_required": "Required",
    "txt_invalid_number": "Invalid Number",
    "txt_value_must_be_greater_than_zero": "{{type}} must be greater than zero",
    "txt_invalid_date_format": "Invalid date format",
    "txt_air_freight": "Air freight",
    "txt_ocean_freight": "Ocean freight",
    "txt_expired": "Expired",
    "txt_rejected": "Rejected",
    "txt_booked": "Booked",
    "txt_valid": "Valid",
    "txt_air": "Air",
    "txt_sea": "Sea",
    "txt_yes": "Yes",
    "txt_your_reference": "Your reference",
    "txt_your_references": "Your references",
    "txt_purchase_references": "Purchase References",
    "txt_direct": "Direct",
    "txt_indirect": "Indirect",
    "txt_rotra_reference": "Rotra reference",
    "txt_cargo": "Cargo",
    "txt_costs": "Costs",
    "txt_new": "NEW!",
    "txt_refreshing": "Refreshing ...",
    "txt_all_in_price": "All-in price",
    "txt_pagination_text": "Showing {{startItemsCount}} - {{endItemsCount}} of {{totalItems}} {{listType}}",
    "txt_total_maximum_container_quantity": "Maximum amount of Containers is {{totalMaximumQuantity}}",
    "txt_transport_method": "Transport method",
    "txt_all_container_types": "All container types",
    "txt_per_kg_per_container": "per KG per Container",
    "txt_select_option_you_would_like_to_book": "Select the option you would like to book",
    "txt_airline": "Airline",
    "txt_invalid_phone_number": "Please enter a valid phone number using digits, spaces, or standard symbols",
    "txt_invalid_container_number": "Invalid container number format (ISO 6346)",
    "txt_invalid_hs_code": "HS code must contain 6 to 18 digits only",
    "field_is_required": "This field is required",
    "field_max_length_128": "This field has a maximum length of 128 characters",
    "field_max_length_400": "This field has a maximum length of 400 characters",
    "field_min_length_5": "This field must contain at least {{min}} characters.",
    "field_max_length_512": "This field must contain at most {{max}} characters.",
    "field_min_value": "Minimum value is {{min}}",
    "field_must_be_positive": "Value must be positive",
    "array_min_items": "Please add at least {{min}} item(s).",
    "array_max_items": "You can add at most {{max}} item(s).",
    "email_is_invalid": "Please enter a valid email address",
    "date_min": "The date cannot be before {{date}}.",
    "date_max": "The date cannot be after {{date}}.",
    "password_invalid_format": "Password must contain at least 8 characters, one uppercase letter, one number, and one special character (!@#$%^&*).",
    "txt_country_is_invalid": "Country is invalid, please select a country from the list",
    "txt_postal_code_invalid": "Postal code is invalid",
    "txt_invalid_email_address": "Invalid e-mail address",
    "txt_invalid_date": "Invalid date format, use dd-mm-yyyy.",
    "txt_loading": "Loading...",
    "txt_today": "Today",
    "txt_tomorrow": "Tomorrow",
    "txt_you": "You",
    "sales": {
      "txt_per_container": "per container",
      "txt_warning_inland_transport_unavailable": "Please note that the charges for inland transport have not been calculated as they are not available for the selected postal code and country ({{postcode}}, {{country_code}}).",
      "txt_inland_transport_could_not_be_calculated": "Inland Transport could not be calculated",
      "txt_charges_not_calculated_not_available": "Please note that the charges for inland transport have not been calculated as they are not available for the selected city",
      "txt_all_in_price_calculation_does_not_have_charges": "Please note that the all-in price calculation does not include charges for inland transport as there are no charges available for the weight provided.",
      "txt_origin": "Origin",
      "txt_destination": "Destination",
      "txt_freight": "Freight",
      "txt_freight_surcharges": "Freight surcharges",
      "txt_precarriage_charges": "Precarriage charges",
      "txt_oncarriage_charges": "Oncarriage charges",
      "txt_inland_transport": "Inland transport",
      "txt_discharge_terminal_surcharges": "Discharge terminal surcharges (not included in total price)",
      "txt_conditional_charges": "Conditional charges",
      "txt_charge": "Charge",
      "txt_description": "Description",
      "txt_amount": "Amount",
      "txt_subtotal": "Subtotal",
      "txt_cargo_charges": "Cargo Charges",
      "txt_uncategorized": "Uncategorized",
      "txt_general_charges": "General charges",
      "txt_charges_option": "Charges option",
      "txt_chargeable_weight": "Chargeable weight",
      "txt_actual_weight": "Actual weight",
      "lbl_days": "DAYS",
      "lbl_container": "CONTAINER",
      "lbl_unknown_unit": "unknown unit",
      "txt_base": "(Base)",
      "txt_minimum_price": "(Minimum Price)",
      "txt_lumpsum_based_on_interval": "Lumpsum based on interval",
      "txt_interval_charge": "Interval charge"
    },
    "languages": {
      "txt_language_en": "English",
      "txt_language_nl": "Dutch",
      "txt_language_pt": "Portuguese",
      "txt_language_es": "Spanish",
      "txt_language_fr": "French",
      "txt_language_de": "German",
      "txt_language_it": "Italian"
    },
    "messages": {
      "txt_translation_disclaimer": "We use machine translations, therefore the translation may be inaccurate",
      "txt_translated_from": "Translated from {{language}}",
      "txt_show_original": "Show original",
      "txt_show_translation": "Show translation",
      "txt_translation_not_available": "Translation not available"
    },
    "notifications": {
      "txt_settings_updated_successfully": "{{type}} settings updated successfully",
      "txt_settings_updated_failed": "{{type}} settings update failed"
    }
  },
  "date_utils": {
    "txt_today_at": "Today at",
    "txt_tomorrow": "Tomorrow",
    "txt_yesterday": "Yesterday",
    "txt_last": "Last"
  },
  "dashboard": {
    "title_dashboard": "Dashboard",
    "lbl_good_morning": "Good morning",
    "lbl_good_afternoon": "Good afternoon",
    "lbl_good_evening": "Good evening",
    "filter": "Filter",
    "calendar": {
      "title_calendar": "Calendar",
      "lbl_more": "more",
      "txt_no_activities": "You don't have any upcoming activities",
      "lbl_arrival": "Arrival",
      "lbl_departure": "Departure",
      "lbl_cargo_pickup": "Cargo pickup",
      "lbl_cargo_delivery": "Cargo delivery"
    },
    "base_widget": {
      "txt_rearrange_widget": "Rearrange by dragging<br />the widget around"
    },
    "exceptions": {
      "title_exceptions": "Exceptions",
      "txt_no_exceptions": "Everything is all right! <br /> No exceptions found in your shipments"
    },
    "watched": {
      "title_watched_shipments": "Watched Shipments",
      "txt_no_watched_shipments": "You are not watching any shipments",
      "txt_watch_shipment": "Click on the <icon /> shown at the top of a shipment page to watch a shipment."
    },
    "spot_rates": {
      "lbl_spot_rates": "Quotes",
      "txt_no_spot_rates_available": "No quotes available",
      "title_book": "Book",
      "txt_starting_from": "Starting from",
      "txt_all_in_price": "All-in price",
      "txt_more_options": "+ {{count}} more options",
      "txt_expires_in_one": "Expires in {{count}} day",
      "txt_expires_in_other": "Expires in {{count}} days",
      "txt_expires_today": "Expires today",
      "txt_quotes": "quotes"
    },
    "client_popover": {
      "lbl_organization": "Organization",
      "txt_account_number": "Account number",
      "alert_info_to_contact_myrotra": "<strong>Always</strong> use the account number {{clientId}} of your organization or the Rotra reference when contacting Rotra.",
      "lbl_address": "Address",
      "lbl_vat_number": "VAT No.",
      "cta_view_organization": "View organization"
    },
    "shipment_routing": {
      "txt_new_eta_later": "New ETA is at least 24 hours later than initially planned",
      "txt_new_eta_earlier": "New ETA is at least 24 hours earlier than initially planned",
      "txt_demurrage_detention_overdue": "There are no free days left for demurrage/detention on at least one or more containers.",
      "txt_demurrage_detention_one_day_left": "There is only one free day left for Demurrage/Detention on at least one or more containers.",
      "txt_routing_will_be_available": "Routing will soon be available",
      "txt_days": "({{daysLabel}} days)"
    },
    "shipments_map": {
      "txt_track_and_trace_data_not_available": "Track & Trace data is not available for this",
      "txt_your_reference": "Your reference",
      "txt_rotra_reference": "Rotra reference",
      "txt_current_location_estimation": "Current location is an estimate based on our schedule. Track & Trace data is not confirmed for this shipment.",
      "txt_new_eta_later_than_planned": "New ETA is at least 24 hours later than initially planned",
      "txt_vessel": "vessel",
      "txt_flight": "flight",
      "txt_unknown": "Unknown"
    },
    "widget": {
      "txt_success": "Your widgets order has been updated",
      "txt_error": "Something went wrong while updating your widgets, please try again"
    }
  },
  "global_search": {
    "ph_search": "Search...",
    "txt_no_shipment_found": "We couldn’t find that shipment.",
    "txt_hint_shipment_search": "Search for shipments by reference, container number or bills of lading..",
    "txt_no_spot_rate_found": "We couldn't find that quote.",
    "txt_hint_spot_rate_search": "Search for quote by reference number..",
    "txt_or_simply": "or simply",
    "txt_no_booking_found": "We couldn't find that booking.",
    "txt_hint_booking_search": "Search for bookings by reference number..",
    "txt_no_address_found": "We couldn't find that address.",
    "txt_hint_address_search": "Search for address by company name..",
    "txt_or_quickly": "or quickly",
    "txt_we_couldnt_find_that": "We couldn't find that, try changing your search phrase..",
    "txt_from": "From",
    "txt_and_delayed": "and delayed",
    "txt_booked_times": "Booked {{count}} times",
    "txt_no_contacts_found": "No contacts found",
    "txt_something_went_wrong": "Something went wrong",
    "cta_check_out_now": "Check out now",
    "valid_organization_button": "This functionality cannot be accessed because your organization is obsolete. Please contact your account manager or our Customer Success team for support if needed.",
    "modal": {
      "ph_search_question": "What are you looking for?",
      "cta_navigation": "Navigation",
      "cta_quotes": "Quotes",
      "cta_contracts": "Contracts",
      "cta_bookings": "Bookings",
      "cta_shipments": "Shipments",
      "cta_quick_actions": "Quick Actions",
      "cta_get_help": "Get Help"
    }
  },
  "app_layout": {
    "txt_english": "English",
    "txt_dutch": "Nederlands"
  },
  "rating_preview": {
    "cta_tooltip_with_feedback": "Click to view feedback",
    "cta_tooltip_without_feedback": "Click to leave feedback",
    "txt_tooltip_rating_is_not_available": "Shipment Rating is not yet available at this time.",
    "dialog": {
      "dismissed": {
        "txt_title": "Rate this Shipment",
        "alert_rating_this_shipment": "Rating this Shipment helps us improve our service. Please take a moment to rate this shipment."
      },
      "rating_preview": {
        "txt_title": "Your rating for this Shipment",
        "txt_user_indicator": "<strong>{{user}}</strong>, left this rating on {{date}}",
        "lbl_no_feedback": "No feedback provided",
        "lbl_feedback": "Feedback:",
        "txt_you": "You"
      }
    }
  },
  "rating_form": {
    "txt_submit_success": "Thank you for your feedback!",
    "txt_submit_error": "An error occurred while submitting your feedback. Please try again later.",
    "txt_description": "Your feedback helps us improve our service. Please take a moment to rate this shipment.",
    "txt_free_input_placeholder": "What could help us improve?",
    "txt_what_do_you_think": "What do you think?",
    "txt_feedback_helps_improve": "Your feedback helps us improve our service. Please take a moment to rate this shipment.",
    "cta_rate_now": "Rate now"
  },
  "quote_requests": {
    "title_requests_and_quotes": "Requests & Quotes",
    "txt_quote_requests": "quote requests",
    "title_quote_request": "Request & Quotes: Quote Request",
    "txt_can't_find_quote_request": "We can't find that quote request",
    "txt_no_quote_request": "No quote requests to show",
    "txt_change_search_phrase_or_filter": "Try changing your search phrase or check your filters.",
    "txt_quote_requests_displayed": "Your quote requests are displayed on this page once you request one.",
    "txt_request_first_quote": "Request your first quote now"
  },
  "sales_teaser": {
    "txt_created": "Created:",
    "txt_last_updated": "Last updated:",
    "txt_unknown": "unknown",
    "txt_all_in_price_disclaimer": "Mentioned price is based on your given shipment specifications, current valid surcharges as well as an estimated rate of exchange. The final amount depends on the rate applicable at the time of shipment.",
    "txt_price_is_excluding_additional_costs": "This price is excluding additional costs as specified here:",
    "txt_additional_costs_explanation": "If additional costs apply, the invoiced total price may be higher.",
    "lbl_option": "Option",
    "txt_all_in_price": "All-in price",
    "txt_transit_time": "Transit time",
    "txt_option_one": "option",
    "txt_option_other": "options",
    "txt_more": "more",
    "txt_cargo_summary": "Cargo summary",
    "txt_amount_of_containers": "Amount of containers:",
    "txt_containers": "Containers:",
    "lbl_contact": "Contact:",
    "txt_your_reference": "Your reference",
    "txt_rotra_reference": "Rotra reference",
    "txt_airline": "Airline"
  },
  "sales_list": {
    "txt_spot_rates": "Quotes"
  },
  "new_quote_request_page": {
    "txt_creating_booking_without_rate_text": "You are creating a booking without a rate",
    "txt_new_quote_request": "New Quote Request",
    "txt_new_quote_as_booking": "New Booking",
    "txt_resume_your_quote_request_text": "Would you like to resume your Quote Request where you left off?",
    "cta_start_new": "No, start new",
    "cta_yes_resume": "Yes, resume",
    "txt_thank_you_for_requesting_quote_text": "Thank you for requesting a quote from us! You will be notified of further progress.",
    "txt_almost_there": "Almost there ...",
    "txt_verify_information": "Please verify your {{type}} information below. Click one of the edit buttons if you need to correct anything, or use the submit button at the top or bottom of this page to submit your request.",
    "cta_submitting": "Submitting ...",
    "txt_general": "General",
    "txt_purchase_references_helper": "Separate multiple references with a comma, space, or enter",
    "txt_purchase_reference_already_added": "'{{reference}}' has already been added",
    "lbl_transport_method": "Transport method",
    "lbl_origin": "Origin",
    "lbl_destination": "Destination",
    "txt_pickup_and_delivery": "Pickup & delivery",
    "lbl_pickup_shipper_address": "Pickup / Shipper address",
    "lbl_delivery_consignee_address": "Delivery / Consignee address",
    "alert_container_details_note": "Please note that although the container details are optional when submitting a quote request, an all-in price can only be offered if the container details are filled in completely. If you wish to receive an all-in price, please fill in the <1>type</1> for all containers.",
    "cta_edit_containers": "Edit containers",
    "txt_yes": "Yes",
    "txt_no": "No",
    "alert_cargo_details_note": "Please note that although the cargo details are optional when submitting a quote request, an all-in price can only be offered if the cargo details are filled in completely. If you wish to receive an all-in price, please fill in the <1>weight, length, width and height</1> of all cargo.",
    "cta_edit_cargo_details": "Edit cargo details",
    "lbl_transit_time": "Transit time",
    "lbl_additional_information": "Additional information",
    "alert_change_organization": "If you change the <1>organization</1>, your selected pickup and delivery addresses, as well as any uploaded attachments, will be reset.",
    "lbl_organization": "Organization",
    "txt_active_organizations": "Active organizations",
    "txt_obsolete_organizations": "Obsolete organizations",
    "txt_select_organization_to_add_address": "Select an organization to be able to add an address",
    "lbl_no_preference": "No preference",
    "cta_delete_container": "Delete container",
    "cta_add_another_container": "Add another container",
    "lbl_per_piece": "per piece",
    "cta_delete_package": "Delete package",
    "cta_add_another_package": "Add another package",
    "ph_describe_contents_of_shipment": "Briefly describe the contents of your shipment",
    "ph_please_enter_additional_information": "Please enter any additional information that might be helpful",
    "txt_invalid_file_name": "Only file names without special characters (Examples: example.pdf, example101.pdf and example_101.pdf) are supported by myRotra.<1/>Please change the file name of your upload in order to continue your quote request.",
    "txt_cargo_details": "Cargo Details",
    "lbl_container_type": "Container type",
    "cta_add_another": "Add Another {{item}}",
    "txt_pc": "pc.",
    "product_ready_date": "Product ready date"
  },
  "contact_field": {
    "cta_edit_contact_information": "Edit contact information",
    "cta_edit_address": "Edit address",
    "cta_add_contact_information": "Add contact information",
    "cta_add_address": "Add address",
    "cta_delete_address": "Delete address",
    "txt_saving": "Saving",
    "update_address_select": "Update Address & Select",
    "txt_contact_information_incomplete": "Contact information is incomplete.",
    "txt_company": "Company",
    "txt_contact_information": "Contact information",
    "txt_no_addresses_found": "No addresses found",
    "ph_search_contacts": "Search contacts",
    "txt_loading_address_book": "Loading address book",
    "txt_name": "Name",
    "lbl_street_address_1": "Street address 1",
    "lbl_street_address_2": "Street address 2",
    "lbl_country": "Country",
    "lbl_postal_code": "Postal code",
    "lbl_city": "City",
    "cta_reset": "Reset",
    "lbl_email": "Email",
    "lbl_phone": "Phone",
    "txt_company_edited": "company edited",
    "txt_from_addressbook": "from addressbook",
    "txt_contact": "Contact",
    "cta_add_new": "Add new",
    "txt_contact_edited": "Contact edited",
    "txt_new_contact": "New contact",
    "txt_contact_person": "Contact person",
    "cta_update": "Update the {{label}}",
    "cta_add": "Add a {{label}}",
    "cta_update_for_your_cargo": "Update the {{label}} for your cargo",
    "cta_select_for_your_cargo": "Select a {{label}} for your cargo"
  },
  "address_book": {
    "cta_update_address_select": "Update Address & Select",
    "cta_update_company_add_contact_select": "Update Company, Add Contact & Select",
    "cta_update_company_select": "Update Company & Select",
    "cta_update_contact_select": "Update Contact & Select",
    "cta_add_contact_select": "Add Contact & Select",
    "cta_save_address_select": "Save Address & Select",
    "cta_select": "Select",
    "txt_invalid_postal_code": "Postal code not valid in selected country"
  },
  "reusable_form_value": {
    "cta_save_value_for_later_reuse": "Save value for later re-use",
    "cta_value_saved_for_later_reuse": "Value saved for later re-use"
  },
  "attachments": {
    "txt_drop_files_here": "Drop the files here ...",
    "txt_drag_and_drop": "Drag 'n drop some files here, or click to select files",
    "txt_unsupported_file_name": "Only file names with ASCII printable characters are supported by myRotra. Please change the file name of your upload in order to continue.",
    "txt_unsupported_type": "The file you are trying to upload is of an unsupported file type. Please try uploading your content in a different file type.",
    "txt_max_files": "Maximum {{filesLeft}} more files, {{maxMbPerFile}}MB per file",
    "txt_only_file_without_special_characters": "Only file names without special characters are supported.",
    "txt_example_file_names": "<b>For example:</b> {{example1}}, {{example2}}, {{example3}}",
    "alert_maximum_amount_of_files_reached": "Maximum amount of files reached",
    "cta_delete": "Delete file",
    "cta_download": "Download"
  },
  "quote_request_detail_page": {
    "txt_rotra_reference": "Rotra reference",
    "txt_quote_request_title": "Quote request {{quoteRequestTitle}}",
    "txt_click_to_copy": "Click to copy this Quote Request",
    "cta_copy_and_continue": "Copy and Continue",
    "txt_copy_quote_request": "Copy Quote Request",
    "txt_copy_quote_request_confirmation": "You're about to copy this quote request to create a new quote request. This will redirect you to the 'Request quote' page. Would you like to proceed?",
    "txt_created": "Created:",
    "txt_last_updated": "Last updated:",
    "alert_quote_request_thank_message": "Thank you for requesting a quote from us! You will be notified of further progress via this page.",
    "alert_your_requested_spot_rate_is_ready": "Your requested quote is ready:",
    "lbl_transport_method": "Transport method",
    "lbl_origin": "Origin",
    "lbl_destination": "Destination",
    "lbl_additional_information": "Additional information",
    "txt_pickup_and_delivery": "Pickup & delivery",
    "lbl_pickup_shipper_address": "Pickup / Shipper address",
    "lbl_delivery_consignee_address": "Delivery / Consignee address",
    "txt_cargo": "Cargo",
    "txt_pieces": "pc.",
    "txt_yes": "Yes",
    "txt_no": "No",
    "lbl_transit_time": "Transit time",
    "txt_chat_cannot_be_used_with_canceled_quote_request": "The messaging feature cannot be used with canceled Quote Requests",
    "txt_quote_request_processed_message_from_spot_rate": "This Quote request has been successfully processed. You can now message us from the Quote.",
    "txt_quote_request_processed_message_from_shipment": "This Quote Request has been successfully processed. You can now message us from the Shipment.",
    "lbl_container_type": "Container type",
    "txt_cargo_detail": "Cargo Detail",
    "alert_quote_request_canceled_message": "This Quote Request has been canceled on {{dateTime}}.",
    "lbl_no_preference": "No preference"
  },
  "messages_v2": {
    "txt_messages": "Messages",
    "txt_no_messages": "There are no messages yet.",
    "txt_messages_failed_to_load": "Messages failed to load.",
    "txt_scroll_down_unnread_message": "Scroll down for unread message",
    "txt_scroll_down_unnread_messages": "Scroll down for {{count}} unread messages",
    "txt_delviered": "Delivered:",
    "txt_read_by": "Read by:",
    "txt_scroll_up_unnread_message_one": "Scroll up for {{count}} unread message",
    "txt_scroll_up_unnread_message_plural": "Scroll up for {{count}} unread messages",
    "lbl_only_show_unread": "Only show unread",
    "txt_marking_as_read": "Marking as read...",
    "cta_mark_as_read": "Mark as read",
    "cta_mark_amount_as_read": "Mark {{count}} as read",
    "cta_mark_all_as_read": "Mark all as read"
  },
  "watch_entity_button": {
    "cta_click_to_watch_this": "Click to watch this {{entityType}}",
    "cta_stop_watching": "Stop watching",
    "cta_watch_now": "Watch now",
    "txt_watching_this": "Watching this {{entityType}}",
    "txt_shipment": "shipment",
    "txt_contract": "contract",
    "txt_booking": "booking",
    "txt_quote": "quote",
    "txt_quote_request": "quote request"
  },
  "sales_item_detail": {
    "txt_loading": "Loading ...",
    "txt_item_not_found": "Item not found"
  },
  "reporting": {
    "txt_title": "Reporting",
    "txt_total_dem_det_days": "Total Dem/Det days",
    "txt_origin_destination": "Origin / Destination",
    "txt_origin_destination_cities": "Origin / Destination cities",
    "txt_total_teu_over_time": "Total TEU over Time",
    "txt_total_teu": "Total TEU",
    "txt_total": "Total:",
    "txt_total_costs": "Total Costs",
    "txt_main_costs_types": "Main Costs Types",
    "txt_inland_costs": "Inland Costs",
    "txt_other_costs": "Other Costs",
    "txt_origin_costs": "Origin Costs",
    "txt_destination_costs": "Destination Costs",
    "txt_freight_costs": "Freight Costs",
    "txt_demurrage_detention_costs": "Demurrage/Detention Costs",
    "txt_origin_destination_costs": "Origin / Destination Costs",
    "txt_fcl_costs": "FCL Costs",
    "txt_lcl_costs": "LCL Costs",
    "txt_air_costs": "Air Costs",
    "txt_truck": "Truck",
    "txt_train": "Train",
    "txt_barge": "Barge",
    "tabs": {
      "txt_general": "General",
      "txt_air": "Air",
      "txt_sea": "Sea",
      "txt_costs": "Costs",
      "txt_custom_report": "Custom Report",
      "txt_emission": "Emission"
    },
    "no_data": {
      "txt_title": "No Data Available",
      "txt_subtitle": "No data matches your current filter criteria. Try adjusting your filters or date range to see shipment data.",
      "cta_clear_filters": "Clear filters"
    },
    "top_bar": {
      "filters": {
        "txt_date_range": "Date Range",
        "date_modal": {
          "txt_title": "Select Date Range",
          "txt_description": "Please choose the start and end dates for filtering the data.",
          "txt_start_date": "Start Date",
          "txt_end_date": "End Date",
          "cta_this_month": "This Month",
          "cta_last_month": "Last Month",
          "cta_ytd": "ytd",
          "cta_last_year": "Last Year"
        },
        "txt_organizations": "Organizations",
        "txt_modality": "Modality",
        "txt_direction": "Direction",
        "txt_carrier": "Carrier",
        "txt_origin": "Origin",
        "txt_destination": "Destination",
        "txt_container_load": "Container load",
        "txt_container_type": "Container type",
        "cta_reset_filters": "Reset Filters",
        "txt_is_direct": "Direct flight"
      },
      "download_modal": {
        "txt_title": "Download Report",
        "txt_description": "You're about to download this report. Choose below which file type you would like to download:",
        "txt_file": "File",
        "txt_confirmation": "Proceed with the download?",
        "cta_cancel": "cancel"
      }
    },
    "graphs": {
      "cta_expand": "Expand",
      "cta_minimize": "Minimize",
      "txt_day": "Day",
      "txt_week": "Week",
      "txt_month": "Month",
      "txt_origin": "Origin",
      "txt_destination": "Destination",
      "txt_shipments": "Shipments",
      "txt_min": "Min",
      "txt_q1": "Q1",
      "txt_median": "Median",
      "txt_q3": "Q3",
      "txt_max": "Max",
      "txt_deviation_iqr": "Deviation (IQR)",
      "txt_unit_day": "d",
      "txt_unit_hour": "h"
    },
    "downloading": {
      "title": "Download Report",
      "description": "You're about to download this report. Choose below which file type you would like to download:",
      "file": "File",
      "note": "Note: Any filters applied to the report will also affect the downloaded file.",
      "confirmation": "Proceed with the download?",
      "cancel": "cancel"
    },
    "general": {
      "cards": {
        "txt_total_shipments": "Total Shipments",
        "txt_total_costs": "Total Costs",
        "txt_total_volume": "Total Volume",
        "txt_total_teu": "Total TEU",
        "txt_total_weight": "Total Weight",
        "txt_total_volume_weight": "Total Volume Weight",
        "txt_total_chargeable_weight": "Total Chargeable Weight",
        "txt_total_co2e": "Total CO2e",
        "txt_average_co2e": "Average CO2e",
        "txt_total_freight_emission": "Total Freight Emission",
        "txt_total_inland_emission": "Total Inland Emission",
        "txt_co2e_trend": "Your CO2e trend",
        "txt_co2e_trend_description": "Compared to last {{period}}",
        "txt_average_weight_per_shipment": "Average Weight per Shipment",
        "txt_freight_costs": "Freight Costs",
        "txt_inland_costs": "Inland Costs",
        "txt_local_costs": "Local Costs",
        "txt_average_cost_per_shipment": "Avg. Cost per Shipment",
        "txt_customs_duties_costs": "Customs Duties Costs",
        "txt_last": "Last",
        "txt_day": "day",
        "txt_week": "week",
        "txt_month": "month"
      },
      "graphs": {
        "txt_shipments_over_time": "Shipments over Time",
        "txt_costs": "Costs over Time (€)",
        "txt_volume_over_time": "Volume over Time (m³)",
        "txt_chargeable_weight_over_time": "Chargeable Weight over Time (KG)",
        "txt_weight_over_time": "Weight over Time (KG)",
        "txt_count": "count",
        "txt_chargeable_weight": "Chargeable Weight",
        "txt_accumulated_count": "Accumulated Count",
        "txt_accumulated_weight": "Accumulated Weight",
        "txt_accumulated_dem_count": "Accumulated Dem Count",
        "txt_accumulated_det_count": "Accumulated Det Count",
        "txt_accumulated_value": "Accumulated Value",
        "txt_accumulated_inland_costs": "Accumulated Inland Costs",
        "txt_accumulated_other_costs": "Accumulated Other Costs",
        "txt_accumulated_customs_duties_costs": "Accumulated Customs Duties Costs",
        "txt_volume": "Volume",
        "txt_total_emission_over_time": "Total Emission over Time",
        "txt_total_emission_over_time_info": "WTT (Well to Tank): emissions from producing and transporting the fuel before it is used.\nTTW (Tank to Wheel): emissions released while burning the fuel during transport.\nAccumulated value: the running total of WTT + TTW over the selected period.",
        "txt_inland_emission_over_time": "Inland Emission over Time",
        "txt_inland_emission_over_time_info": "Emissions from inland transport modes (truck, barge and train).\nAccumulated value: the running total of inland emissions over the selected period.",
        "txt_freight_emission_over_time": "Freight Emission over Time",
        "txt_freight_emission_over_time_info": "Emissions from main freight transport modes (air and sea).\nAccumulated value: the running total of freight emissions over the selected period."
      }
    },
    "otp": {
      "cards": {
        "txt_on_time_performance": "On-time performance (%)",
        "txt_average_deviation_time": "Average deviation time",
        "txt_average_transit_time": "Average transit time"
      },
      "graphs": {
        "txt_performance_per_carrier": "On-time performance per carrier",
        "txt_performance_per_airline": "On-time performance per airline",
        "txt_deviation_per_carrier": "Deviation per carrier",
        "txt_deviation_per_airline": "Deviation per airline",
        "txt_transit_time_per_routing": "Average transit time per routing",
        "txt_axis_otp_percent": "On-time performance (%)",
        "txt_axis_carrier": "Carrier",
        "txt_axis_airline": "Airline",
        "txt_deviation": "Deviation",
        "txt_axis_routing": "Routing",
        "txt_axis_transit_hours": "Transit time",
        "txt_otp_over_time": "On-time performance over time",
        "txt_axis_period": "Period",
        "txt_overall": "Overall performance",
        "txt_overall_count": "Overall count",
        "txt_air_shipments": "Air shipments",
        "txt_sea_shipments": "Sea shipments"
      },
      "configurations": {
        "txt_title": "On-time performance configurations",
        "txt_air_threshold": "Air threshold",
        "txt_sea_threshold": "Sea threshold",
        "txt_hour": "hour",
        "txt_hours": "hours",
        "txt_day": "day",
        "txt_days": "days"
      }
    }
  },
  "custom_reporting": {
    "txt_general": "General",
    "txt_air": "Air",
    "txt_sea": "Sea",
    "txt_costs": "Costs",
    "txt_emission": "Emission",
    "lbl_newest_first": "Newest first",
    "lbl_oldest_first": "Oldest first",
    "lbl_weekly": "Weekly",
    "lbl_monthly": "Monthly",
    "lbl_yearly": "Yearly",
    "txt_loading": "Loading custom reports...",
    "txt_reports_count": "You have {{count}} custom reports",
    "alert_created_success": "Successfully created Custom Report",
    "alert_deleted_success": "Successfully deleted Custom Report",
    "cta_create_report": "Create Report",
    "txt_name": "Name",
    "txt_organization": "Organization",
    "txt_category": "Category",
    "txt_creation_date": "Creation Date",
    "txt_generation_interval": "Generation Interval",
    "txt_recurring_report": "Recurring Report",
    "txt_no_results_title": "We can't find that Custom Report",
    "txt_no_results_desc": "Try changing your search phrase or check your filters.",
    "txt_empty_title": "You don't have any custom reports yet",
    "txt_empty_desc": "Start making your first personal report now",
    "lbl_category": "Category",
    "lbl_edit_report": "Edit Custom Report",
    "cta_download": "Download",
    "lbl_create_report_title": "Create Report",
    "txt_step_general_info": "General Information",
    "txt_step_select_columns": "Select Columns",
    "cta_generate_report": "Generate Report",
    "cta_generating": "Generating...",
    "txt_step1_intro_title": "You are about to generate your own customized report",
    "txt_step1_intro_desc": "Please fill in the details below",
    "txt_report_name_placeholder": "Report Name...",
    "txt_generation_mode_question": "Do you want to generate this report once, or make it a recurring report?",
    "lbl_generate_once": "Generate Once",
    "lbl_recurring_generation": "Recurring Generation",
    "lbl_generation_interval": "Generation Interval",
    "lbl_period_week": "week",
    "lbl_period_month": "month",
    "lbl_period_year": "year",
    "txt_recurring_start_explanation": "The first report will be generated at the beginning of current {{period}}",
    "lbl_from": "From",
    "lbl_to": "To",
    "err_date_range": "From must be before To",
    "lbl_configure_columns": "Configure Report Columns",
    "txt_drag_instruction": "Drag items from the left to the right to include them in your report.",
    "lbl_available_columns": "Available Columns",
    "cta_add_all": "Add All",
    "cta_remove_all": "Remove All",
    "lbl_columns_to_include": "Columns to Include",
    "txt_drag_placeholder": "Drag columns here to include them",
    "err_no_columns_selected": "* It is not possible to create/update a custom report without choosing columns you want to download.",
    "lbl_edit_report_title": "Edit Report: {{name}}",
    "cta_update": "Update",
    "cta_updating": "Updating...",
    "col_lbl_purchase_reference": "Purchase Reference",
    "col_desc_purchase_reference": "The unique reference identifier for the purchase order.",
    "col_lbl_custom_duties_costs": "Customs Duties",
    "col_desc_custom_duties_costs": "Total costs related to customs taxes and duties for this shipment.",
    "col_lbl_shipment_no": "Shipment No",
    "col_desc_shipment_no": "The unique identifier for the shipment.",
    "col_lbl_client_reference": "Client Reference",
    "col_desc_client_reference": "The reference number provided by the client.",
    "col_lbl_acc_no": "Account No",
    "col_desc_acc_no": "The account number associated with the shipment.",
    "col_lbl_modality": "Modality",
    "col_desc_modality": "The type of transport (e.g., Sea, Air).",
    "col_lbl_direction": "Direction",
    "col_desc_direction": "Whether the shipment is Import or Export.",
    "col_lbl_service": "Service",
    "col_desc_service": "The specific service level used (e.g., FCL, LCL).",
    "col_lbl_module": "Module",
    "col_desc_module": "The operational module used for this shipment.",
    "col_lbl_incoterm": "Incoterm",
    "col_desc_incoterm": "International Commercial Terms defining responsibilities.",
    "col_lbl_is_direct": "Direct Flight",
    "col_desc_is_direct": "Indicates if the shipment is a direct flight.",
    "col_lbl_stops": "Stops",
    "col_desc_stops": "Number of stops for air shipments.",
    "col_lbl_book_period": "Booking Period",
    "col_desc_book_period": "The period when the booking was made.",
    "col_lbl_logistic_spends": "Logistic Spends",
    "col_desc_logistic_spends": "Total spend on logistics for this shipment.",
    "col_lbl_teu": "TEU",
    "col_desc_teu": "Twenty-foot Equivalent Unit (container volume).",
    "col_lbl_volume": "Volume",
    "col_desc_volume": "The volume of the shipment (CBM).",
    "col_lbl_volume_weight": "Volume Weight",
    "col_desc_volume_weight": "The volumetric weight calculation.",
    "col_lbl_weight": "Gross Weight",
    "col_desc_weight": "The total gross weight of the shipment.",
    "col_lbl_chargeable_weight": "Chargeable Weight",
    "col_desc_chargeable_weight": "The weight used for calculating freight charges.",
    "col_lbl_container_load": "Container Load",
    "col_desc_container_load": "Load type (FCL/LCL).",
    "col_lbl_container_number": "Container Number",
    "col_desc_container_number": "The unique ID of the container.",
    "col_lbl_container_type": "Container Type",
    "col_desc_container_type": "Type of container (e.g., 20GP, 40HC).",
    "col_lbl_volume_teu": "Volume (TEU)",
    "col_desc_volume_teu": "Volume expressed in TEU.",
    "col_lbl_origin": "Origin",
    "col_desc_origin": "The origin location code or name.",
    "col_lbl_origin_country": "Origin Country",
    "col_desc_origin_country": "The country where the shipment originates.",
    "col_lbl_destination": "Destination",
    "col_desc_destination": "The destination location code or name.",
    "col_lbl_destination_country": "Destination Country",
    "col_desc_destination_country": "The country where the shipment is destined.",
    "col_lbl_dem_days": "Demurrage Days",
    "col_desc_dem_days": "Number of days charged for demurrage.",
    "col_lbl_det_days": "Detention Days",
    "col_desc_det_days": "Number of days charged for detention.",
    "col_lbl_demdet_days": "Dem/Det Days",
    "col_desc_demdet_days": "Combined demurrage and detention days.",
    "col_lbl_dem_costs": "Demurrage Costs",
    "col_desc_dem_costs": "Costs incurred for demurrage.",
    "col_lbl_det_costs": "Detention Costs",
    "col_desc_det_costs": "Costs incurred for detention.",
    "col_lbl_demdet_costs": "Dem/Det Costs",
    "col_desc_demdet_costs": "Combined demurrage and detention costs.",
    "col_lbl_yoc_costs": "YOC Costs",
    "col_desc_yoc_costs": "Yard Occupancy Charges.",
    "col_lbl_demdetadminfee_costs": "Admin Fee",
    "col_desc_demdetadminfee_costs": "Administrative fees for Dem/Det.",
    "col_lbl_storage_costs": "Storage Costs",
    "col_desc_storage_costs": "Costs for storage at the terminal/port.",
    "col_lbl_warehouserent_costs": "Warehouse Rent",
    "col_desc_warehouserent_costs": "Costs for warehouse rental.",
    "col_lbl_freight_costs": "Freight Costs",
    "col_desc_freight_costs": "Main freight charges.",
    "col_lbl_origin_costs": "Origin Costs",
    "col_desc_origin_costs": "Local charges at origin.",
    "col_lbl_destination_costs": "Destination Costs",
    "col_desc_destination_costs": "Local charges at destination.",
    "col_lbl_road_costs": "Road Costs",
    "col_desc_road_costs": "Costs for road transport (pre/on-carriage).",
    "col_lbl_internal_costs": "Internal Costs",
    "col_desc_internal_costs": "Internal handling costs.",
    "col_lbl_other_costs": "Other Costs",
    "col_desc_other_costs": "Miscellaneous costs.",
    "col_lbl_total_costs": "Total Costs",
    "col_desc_total_costs": "The sum of all costs.",
    "col_lbl_inland_truck_wtt": "Truck WTT",
    "col_desc_inland_truck_wtt": "Truck emissions: Well-to-Tank.",
    "col_lbl_inland_truck_ttw": "Truck TTW",
    "col_desc_inland_truck_ttw": "Truck emissions: Tank-to-Wheel.",
    "col_lbl_inland_truck_total": "Truck Total",
    "col_desc_inland_truck_total": "Total truck emissions.",
    "col_lbl_inland_barge_wtt": "Barge WTT",
    "col_desc_inland_barge_wtt": "Barge emissions: Well-to-Tank.",
    "col_lbl_inland_barge_ttw": "Barge TTW",
    "col_desc_inland_barge_ttw": "Barge emissions: Tank-to-Wheel.",
    "col_lbl_inland_barge_total": "Barge Total",
    "col_desc_inland_barge_total": "Total barge emissions.",
    "col_lbl_inland_train_wtt": "Train WTT",
    "col_desc_inland_train_wtt": "Train emissions: Well-to-Tank.",
    "col_lbl_inland_train_ttw": "Train TTW",
    "col_desc_inland_train_ttw": "Train emissions: Tank-to-Wheel.",
    "col_lbl_inland_train_total": "Train Total",
    "col_desc_inland_train_total": "Total train emissions.",
    "col_lbl_freight_sea_wtt": "Sea Freight WTT",
    "col_desc_freight_sea_wtt": "Sea freight emissions: Well-to-Tank.",
    "col_lbl_freight_sea_ttw": "Sea Freight TTW",
    "col_desc_freight_sea_ttw": "Sea freight emissions: Tank-to-Wheel.",
    "col_lbl_freight_sea_total": "Sea Freight Total",
    "col_desc_freight_sea_total": "Total sea freight emissions.",
    "col_lbl_freight_air_wtt": "Air Freight WTT",
    "col_desc_freight_air_wtt": "Air freight emissions: Well-to-Tank.",
    "col_lbl_freight_air_ttw": "Air Freight TTW",
    "col_desc_freight_air_ttw": "Air freight emissions: Tank-to-Wheel.",
    "col_lbl_freight_air_total": "Air Freight Total",
    "col_desc_freight_air_total": "Total air freight emissions.",
    "col_lbl_transit_hub_wtt": "Hub WTT",
    "col_desc_transit_hub_wtt": "Hub handling emissions: Well-to-Tank.",
    "col_lbl_transit_hub_ttw": "Hub TTW",
    "col_desc_transit_hub_ttw": "Hub handling emissions: Tank-to-Wheel.",
    "col_lbl_transit_hub_total": "Hub Total",
    "col_desc_transit_hub_total": "Total hub handling emissions.",
    "col_lbl_emission_wtt": "Total WTT",
    "col_desc_emission_wtt": "Grand total emissions: Well-to-Tank.",
    "col_lbl_emission_ttw": "Total TTW",
    "col_desc_emission_ttw": "Grand total emissions: Tank-to-Wheel.",
    "col_lbl_emission_total": "Grand Total Emission",
    "col_desc_emission_total": "Total carbon footprint for the shipment.",
    "col_lbl_arrived_planned": "Planned arrival time",
    "col_desc_arrived_planned": "The planned time when the shipment was scheduled to arrive.",
    "col_lbl_arrived_actual": "Actual arrival time",
    "col_desc_arrived_actual": "The actual time when the shipment arrived.",
    "col_lbl_departed_planned": "Planned departure time",
    "col_desc_departed_planned": "The planned time when the shipment was scheduled to depart.",
    "col_lbl_departed_actual": "Actual departure time",
    "col_desc_departed_actual": "The actual time when the shipment departed.",
    "col_lbl_arrival_diff": "Arrival deviation (h)",
    "col_desc_arrival_diff": "Difference between planned and actual arrival time, in hours.",
    "col_lbl_departed_diff": "Departure deviation (h)",
    "col_desc_departed_diff": "Difference between planned and actual departure time, in hours.",
    "col_lbl_transit_time": "Transit time (h)",
    "col_desc_transit_time": "Total transit time of the shipment, in hours.",
    "col_lbl_shipper": "Shipper",
    "col_desc_shipper": "The sender or party responsible for initiating the shipment.",
    "col_lbl_consignee": "Consignee",
    "col_desc_consignee": "The receiver or party to whom the shipment is destined.",
    "col_lbl_carrier_name": "Carrier name",
    "col_desc_carrier_name": "Name of the carrier responsible for transporting the shipment.",
    "lbl_delete_report_title": "Delete {{name}}",
    "txt_delete_report_confirm": "Are you sure you want to delete this report named {{name}}? This action cannot be undone.",
    "lbl_end_date": "End Date (Optional)"
  },
  "watched_icon": {
    "txt_you_are_watching": "You are watching this",
    "txt_others_are_watching": "Others are watching this"
  },
  "messages_icon": {
    "txt_unread_messages": "You have {{count}} unread messages for this {{entity}}",
    "shipment": "shipment",
    "quote_request": "quote request",
    "spot_rate": "quote"
  },
  "spot_rates": {
    "title_spot_rates": "Request & Quotes: Spot rates",
    "txt_can't_find_spot_rate": "We can't find that quote",
    "txt_no_spot_rates": "No quotes to show",
    "txt_change_search_phrase_or_filter": "Try changing your search phrase or check your filters.",
    "txt_spot_rates_displayed_on_this_page": "Your quotes are displayed on this page once you request one.",
    "txt_spot_rates": "quotes"
  },
  "spot_rates_detail": {
    "cta_click_to_copy_spot_rate": "Click to copy this Quote",
    "cta_copy_and_continue": "Copy and Continue",
    "cta_copy_spot_rate": "Copy Quote",
    "txt_copy_confirmation": "You're about to copy this quote to create a new quote request. This will redirect you to the 'Request quote' page. Would you like to proceed?",
    "txt_created": "Created:",
    "txt_last_updated": "Last updated:",
    "cta_view_new_spot_rate": "View new quote",
    "txt_quote_rejected_alert": "{{user}} rejected this quote on {{dateTime}}.<br/> Reason: {{reason}}",
    "txt_reason": "Reason",
    "txt_this_spot_rate_was_rejected": "This quote was rejected on:",
    "txt_this_spot_rate_expired": "This quote expired on:",
    "txt_this_spot_rate_cannot_be_booked": "This quote cannot be booked because the organization you are trying to book with is obsolete.",
    "txt_you_have_rejected_the_quotation": "You have rejected the quotation.",
    "alert_requested_booking": "You have requested a booking",
    "txt_booking_option_message": "for option {{option}} on {{date}}",
    "alert_no_booking_options": "An unexpected error occurred. This quote cannot be booked at this moment. Please try again later.",
    "cta_book_now": "Book now",
    "cta_book": "Book",
    "cta_download": "Download",
    "cta_view_spot_rate_pdf": "View quote",
    "cta_view_pdf": "View",
    "txt_reject_spot_rate": "Reject quote",
    "txt_reject_spot_rate_message": "Please note that rejecting the quote will reject all of the options that are part of it.",
    "txt_reject_spot_rate_message_2": "If you simply wish to book one option and reject the others, you can just click the book button after selecting the desired option, then once you placed your booking the other options willautomatically be considered 'rejected'.",
    "lbl_why_reject_spot_rate": "Why do you reject this quote?",
    "txt_reject_message_too_long": "You are over the maximum amount of text, please make your reason shorter.",
    "book_from_spot_rate": "Book from quote",
    "cta_continue_to_booking": "Continue to Booking",
    "lbl_select_the_option_to_book": "Select one of the options below to continue your booking.",
    "txt_origin": "origin",
    "txt_destination": "destination",
    "txt_all_containers_supported": "All containers supported",
    "txt_any_location": "Any location",
    "txt_transit_flight": "Transit flight",
    "txt_direct_flight": "Direct flight",
    "txt_via": "via ",
    "txt_transit_time": "Transit time",
    "txt_airline": "Airline",
    "txt_carrier": "Carrier",
    "txt_coloader": "Coloader",
    "txt_supports_only_destination_and_road_charges": "This option only supports destination & road charges at location",
    "txt_only_inland_at_origin": "Only inland at origin",
    "txt_only_inland_at_destination": "Only inland at destination",
    "txt_price_available_in_next_steps": "Price available in next steps",
    "txt_rejected_title": "The messaging feature cannot be used with rejected Quotes",
    "txt_expired_adjusted_title": "The messaging feature cannot be used with expired Quotes",
    "txt_has_shipment": "This Quote has been successfully processed. You can now message us from the Shipment.",
    "txt_chargeable": "Chargeable",
    "txt_actual": "Actual",
    "txt_days": "days",
    "txt_error_multiple_total_prices": "Error: multiple total prices found",
    "txt_reject_quotation": "Reject quotation",
    "txt_terms_and_conditions": "Terms & Conditions",
    "sea": {
      "txt_any_origin": "Any origin",
      "txt_any_destination": "Any destination",
      "txt_expected_terminal": "Expected terminal",
      "txt_load_terminal": "Load terminal",
      "txt_all_in_price_explanation": "Indicated all-in amount is based on today’s rate of exchange (USD → EUR), final invoice will be based on the vessel exchange rate at time of shipment and may differ.\n\nFuel surcharges (if mentioned or included) are variable and will be calculated at time of (road)transport.",
      "txt_all_in_price_explanation_belgium": "Current all-in amount is based on today’s USD to EUR exchange rate. Final invoice will be based on exchange rate valid at time of shipment and may differ.",
      "alert_all_in_price_info": "Unable to calculate all-in price for this quote, please download the quote using the download button below to view all charges.",
      "lbl_valid_until": "Valid until:",
      "txt_charges_breakdown": "Charges breakdown:",
      "lbl_total_cargo_charges": "Total cargo charges:",
      "cta_view_details": "View details",
      "lbl_total_general_charges": "Total general charges:",
      "txt_cargo_quantity": "Cargo",
      "lbl_contact": "Contact",
      "txt_quote": "Quote"
    },
    "air": {
      "txt_any_location": "Any location",
      "txt_airline": "Airline:",
      "txt_routing": "Routing:",
      "txt_any_origin": "Any origin",
      "txt_any_destination": "Any destination",
      "lbl_contact": "Contact",
      "txt_option": "Option",
      "txt_all_in_price_description": " Mentioned price is based on your given shipment specifications, current valid surcharges as well as an estimated rate of exchange. The final amount depends on the rate applicable at the time of shipment.",
      "lbl_valid_until": "Valid until:",
      "lbl_airline": "Airline:",
      "lbl_routing": "Routing:",
      "lbl_transit_time": "Transit time",
      "txt_charges_breakdown": "Charges breakdown:",
      "lbl_total_cargo_charges": "Total cargo charges:",
      "cta_view_details": "View details",
      "lbl_total_general_charges": "Total general charges:",
      "txt_transit_time": "Transit time:"
    },
    "cargo": {
      "txt_goods_description": "Goods description:",
      "txt_volume": "Volume",
      "txt_dimensions": "Dimensions",
      "txt_delivery": "Delivery",
      "txt_extra_stops": "Extra Stops",
      "txt_dg": "DG",
      "txt_total": "Total",
      "txt_yes": "Yes"
    },
    "teaser": {
      "txt_booked_on": "Booked on:",
      "txt_rejected_on": "Rejected on:",
      "txt_expired_on": "Expired on:",
      "txt_valid_until": "Valid until:",
      "txt_any_origin": "Any origin",
      "txt_any_destination": "Any destination"
    },
    "conditional_charges": {
      "txt_conditional_charges": "Conditional Charges",
      "txt_local_origin": "Local Origin",
      "txt_local_destination": "Local Destination",
      "txt_rate": "Rate",
      "txt_extra_info": "Extra Info",
      "txt_from": "From",
      "txt_per": "per",
      "txt_base": "Base:",
      "txt_minimum": "Minimum:",
      "txt_weight": "weight",
      "txt_charge": "Charge",
      "txt_description": "Description",
      "txt_port": "Port",
      "txt_period": "Period",
      "txt_free": "Free",
      "txt_per_day": "per day",
      "txt_first": "First",
      "txt_inland_transport": "Inland Transport"
    },
    "organization_obsolete": {
      "alert_organization_will_not_be_accessible": "This organization will soon no longer be accessible on myRotra",
      "txt_organization_is_obsolete1": "This organization is obsolete. If you need any assistance, please",
      "txt_organization_is_obsolete2": "your account manager or our Customer Success Team.",
      "cta_contact": "contact",
      "txt_this_organization_is_marked_as_obsolete": "This organization is marked as obsolete. As such, it is no longer possible to use this organization for requesting quotes or making bookings. Please note that after 12 weeks from the delivery of all your active shipments, quotes, quotations and contracts, this organization will no longer be accessible on myRotra.",
      "txt_need_support": "Need support?"
    },
    "charges": {
      "alert_remark": "Remark:",
      "txt_general_charges": "General charges",
      "txt_charges_option": "Charges option",
      "txt_additional_charges_in_case_of_events": "Additional charges, in case of exceptional events",
      "txt_will_be_added_in_case_of_events": "Will be added in case of certain events",
      "txt_origin": "Origin",
      "txt_destination": "Destination",
      "txt_freight": "Freight",
      "txt_freight_surcharges": "Freight surcharges",
      "txt_precarriage_charges": "Precarriage charges",
      "txt_oncarriage_charges": "Oncarriage charges",
      "txt_inland_transport": "Inland transport",
      "txt_discharge_terminal_surcharges": "Discharge terminal surcharges (not included in total price)",
      "txt_conditional_charges": "Conditional charges",
      "txt_charge": "Charge",
      "txt_description": "Description",
      "txt_amount": "Amount",
      "txt_subtotal": "Subtotal",
      "txt_cargo_charges": "Cargo Charges",
      "txt_all_in_price_calculation_does_not_have_charges": "Please note that the all-in price calculation does not include charges for inland transport as there are no charges available for the weight provided.",
      "txt_charges_not_calculated_not_available": "Please note that the charges for inland transport have not been calculated as they are not available for the selected city",
      "txt_inland_transport_could_not_be_calculated": "Inland Transport could not be calculated",
      "txt_warning_inland_transport_unavailable": "Please note that the charges for inland transport have not been calculated as they are not available for the selected postal code and country ({{postcode}}, {{country_code}})."
    },
    "txt_select_option_you_would_like_to_book": "Select the option you would like to book"
  },
  "customer_success": {
    "txt_have_any_questions_contact_manager": "If you have any questions, please contact your account manager.",
    "txt_can_also_contact_our_customer_success": "You can also contact our Customer Success team using the provided details below. They will be more than happy to assist you."
  },
  "delete_user_dialog": {
    "delete_confirmation": {
      "txt_title": "Are you sure you want to remove this user?",
      "txt_message": "This will remove {{user}} from organization {{organization_name}}. This is User will no longer have access to this organization's data on myRotra.",
      "alert_assign_to_user": "The data listed below are currently watched by {{user}}. You will automatically be assigned to watch the data as an admin user. If this is not preferred, please assign other users from your organization to monitor the data instead."
    },
    "delete_notification": {
      "alert_succes": "Succesfully removed user from organization",
      "alert_failure": "Failed to remove user from organization"
    }
  },
  "contracts": {
    "txt_pageTitle_contracts": "contracts",
    "teaser": {
      "cta_view_shipment": "View {{count}} shipment",
      "cta_view_shipment_plural": "View {{count}} shipments",
      "cta_view_booking": "View {{count}} booking",
      "cta_view_booking_plural": "View {{count}} bookings",
      "cta_view_contract": "View contract",
      "txt_organization": "Organization",
      "alert_contract_expired_on": "This contract expired on: {{date}}",
      "alert_contract_rejected_on": "This contract was rejected on: {{date}}",
      "cta_view_new_contract": "View new contract",
      "cta_calculate_and_book": "Calculate & Book",
      "txt_valid_until": "Valid until",
      "txt_expires_today": "Expires today",
      "txt_expires_in": "Expires in {{count}} day",
      "txt_expires_in_plural": "Expires in {{count}} days",
      "txt_departing_airports": "Departing airports",
      "txt_ports_of_loading": "Ports of Loading",
      "txt_arriving_airports": "Arriving airports",
      "txt_ports_of_discharge": "Ports of Discharge",
      "txt_contract_reference_incoterm": "Contract reference - Incoterm",
      "lbl_reference": "Reference"
    },
    "single_channel": {
      "txt_book_from_contract": "Book from contract",
      "txt_select_option_to_book": "Select the option you would like to book",
      "txt_continue_to_booking": "Continue to Booking",
      "alert_based_on_contract_visible_option": "Based on the selected contract the following bookable option is available, please continue to the booking process.",
      "alert_based_on_contract_visible_option_other": "Based on the selected contract the following bookable options is available, please continue to the booking process."
    },
    "contracts_detail": {
      "txt_created": "Created:",
      "txt_last_updated": "Last updated:",
      "txt_contract_cannot_be_used": "This contract cannot be used for submitting a booking because the organization is obsolete.",
      "alert_view_new_contract": "View new contract",
      "alert_contract_expired_on": "This contract expired on: {{date}}",
      "txt_rejected_this_contract_on": "{{user}} rejected this contract on {{date}}<br />Reason: <i>{{reason}}</i>",
      "alert_contract_was_rejected_on": "This contract was rejected on {{date}}",
      "alert_last_booking_was_requested_on": "Your last booking was requested on:",
      "lbl_valid_until": "Valid until:",
      "txt_expires_today": "Expires today",
      "txt_percent_of_container_price": "{{percentage}}% of the container price with a minimum of {{price}}",
      "txt_succesfully_rejected_contract": "You have succesfully rejected this contract",
      "txt_reason_to_reject_contract": "You are about to reject this contract, please fill in a reason.",
      "txt_succesfully_rejected": "Succesfully rejected",
      "cta_reject": "Reject",
      "lbl_reason": "Reason",
      "txt_maximum_amount_of_text_for_reason": "You are over the maximum amount of text, please make your reason shorter.",
      "alert_contract_cannot_be_booked": "This contract cannot be booked because all the freight options are expired. Please contact your contact person.",
      "txt_cannot_be_accessed_because_organization_is_obsolete": "This functionality cannot be accessed because your organization is obsolete. Please contact your account manager or our Customer Success team for support if needed.",
      "cta_reject_contract": "Reject contract",
      "cta_calculate_and_book": "Calculate & Book",
      "cta_view": "View",
      "txt_shipment": "shipment",
      "cta_view_shipment_one": "View {{count}} shipment",
      "cta_view_shipment_plural": "View {{count}} shipments",
      "cta_view_booking_one": "View {{count}} booking",
      "cta_view_booking_plural": "View {{count}} bookings",
      "cta_download": "Download",
      "cta_view_contract_pdf": "View contract",
      "cta_view_pdf": "View",
      "lbl_contact": "Contact",
      "txt_routings": "Routings",
      "txt_coloader": "Coloader",
      "txt_minimum_rate": "Minimum Rate",
      "txt_departing_airports": "Departing airports",
      "txt_ports_of_loading": "Ports of Loading",
      "txt_arriving_airports": "Arriving airports",
      "txt_ports_of_discharge": "Ports of Discharge",
      "txt_no_routings_in_contract": "No routings in contract",
      "txt_freight_charges": "Freight Charges",
      "txt_remark": "Remark:",
      "txt_surcharges": "Surcharges",
      "txt_any_port": "Any port",
      "txt_carriage": "Carriage",
      "txt_including_tare": "including tare",
      "txt_excluding_tare": "excluding tare",
      "txt_up_to_interval": "up to {{steps}}",
      "txt_over": "over",
      "txt_minimum_price": "Minimum price:",
      "txt_calculated_over": "Calculated over",
      "txt_precarriage_charges": "Pre-Carriage Charges",
      "txt_oncarriage_charges": "On-Carriage Charges",
      "txt_local_charges": "Local Charges",
      "txt_origin": "Origin",
      "alert_remark": "Remark:",
      "txt_destination": "Destination",
      "txt_charge": "Charge",
      "txt_rate": "Rate",
      "txt_from": "From",
      "txt_base": "Base:",
      "txt_per": "per",
      "txt_minimum": "Minimum:",
      "txt_chargeable_weight": "Chargeable weight",
      "txt_actual_weight": "Actual weight",
      "txt_road_charges": "Road charges",
      "txt_city": "City",
      "txt_price": "Price",
      "txt_container": "container",
      "txt_surcharge_info": "{{percentage}}% of the container price a minimum of {{price}}",
      "txt_fuel_surcharge_description": "A fuel surcharge of {{percentage}}% is calculated over transport rate and terminal surcharge. The fuel surcharge is variable per month. The minimum fuel surcharge is: {{minimumPrice}}.",
      "txt_zip_codes_zone": "Zip codes zone:",
      "txt_cubic_meter": "Cubic meter",
      "txt_loadmeter": "Loadmeter",
      "txt_fuel_surcharge_note": "Excluding fuel surcharge of {{percentage}}%, which is calculated over transport rate. Fuel surcharge is variable per month. The minimum fuel surcharge is: {{minimumPrice}}.",
      "txt_zip_codes_zone_description": "Charges applicable to addresses within the following zip code zones:",
      "txt_weight_up_to": "Weight up to",
      "txt_fuel_surcharge_excluding": "Excluding fuel surcharge of {{percentage}}%, which is calculated over the road transport charges with a minimum of {{minimumPrice}}.",
      "txt_additional_costs": "For our additional costs, please check",
      "txt_demurrage_detention": "Demurrage & Detention",
      "txt_extra_info": "Extra info",
      "txt_port": "Port",
      "txt_period": "Period",
      "txt_free": "Free",
      "txt_per_day": "per day",
      "txt_first": "First",
      "txt_general_conditions": "General conditions",
      "txt_option": "Option",
      "txt_expires": "Expires",
      "alert_option_expired_on": "This option expired on:",
      "txt_freight_surcharges": "Freight surcharges",
      "txt_surcharge": "Surcharge",
      "txt_weight": "Weight",
      "txt_upto": "Upto",
      "cta_contact": "Contact",
      "txt_no_contracts": "You don't have any contracts. You can contact our sales department to reqest a contract.",
      "txt_no_contracts_to_show": "No contracts to show",
      "txt_need_support": "Need support?",
      "txt_displayed_on_the_page_once_available": "Your contracts are displayed on this page once they become available.",
      "txt_try_changing_search_phrase": "Try changing your search phrase or check your filters.",
      "txt_all_container_types": "All container types",
      "txt_per_kg_per_container": "per KG per Container",
      "txt_you": "You"
    }
  },
  "valid_organization_button": {
    "valid_organization_button": "This functionality cannot be accessed because your organization is obsolete. Please contact your account manager or our Customer Success team for support if needed."
  },
  "bookings": {
    "lbl_with_rate": "With rate",
    "lbl_without_rate": "Without rate",
    "txt_cant_find_booking": "We can't find that booking",
    "txt_try_changing_search_phrase": "Try changing your search phrase or check your filters.",
    "txt_bookings": "bookings",
    "teaser": {
      "lbl_booking_without_rate": "Booking without Rate",
      "txt_booked_on": "Booked on:",
      "txt_last_updated": "Last updated:",
      "txt_shipper": "Shipper",
      "txt_cargo_description": "Cargo description:",
      "txt_cargo_unknown": "Cargo unknown",
      "txt_show_less": "Show less",
      "txt_show_more": "Show more",
      "txt_pickup_and_delivery": "Pickup & delivery",
      "lbl_pickup_shipper_address": "Pickup /\nShipper address",
      "lbl_delivery_consignee_address": "Delivery /\nConsignee address"
    },
    "detail": {
      "lbl_booking_without_rate": "Booking without Rate",
      "txt_requested_this_booking_on": "{{name}} requested this booking on {{date}}",
      "txt_you_requested_this_booking_on": "You requested this booking on {{date}}",
      "lbl_thank_you_for_creating_booking_with_us": "Thank you for creating a booking with us! You will be notified of further progress via this page.",
      "cta_view_shipment": "view shipment",
      "txt_your_shipment_is_ready": "Your shipment is ready",
      "txt_pieces": "pc.",
      "txt_yes": "Yes",
      "txt_no": "No",
      "txt_transit_time": "Transit time",
      "lbl_additional_information": "Additional information",
      "txt_quotation": "Quotation",
      "txt_airline": "Airline",
      "txt_via": "Via",
      "txt_coloader": "Coloader",
      "txt_documents": "Documents",
      "txt_no_shipment_documents": "No shipment documents added by Rotra yet.",
      "cta_show_less": "Show less",
      "txt_more": "more",
      "txt_container": "container",
      "txt_pickup_address": "Pickup Address",
      "txt_delivery_address": "Delivery Address",
      "txt_shipper": "Shipper",
      "txt_consignee": "Consignee",
      "lbl_pickup_city": "Pickup City",
      "lbl_delivery_city": "Delivery City",
      "txt_pc": "pc.",
      "txt_additional_information": "Additional information",
      "cta_view": "View",
      "txt_quote": "Quote",
      "txt_view_more_details": "View more details",
      "txt_hide_details": "Hide details",
      "txt_cargo_contains_dangerous_goods": "Cargo contains dangerous goods",
      "cta_add_cargo_description": "Add cargo description",
      "cta_add_cargo": "Add cargo",
      "txt_goods_description": "Goods description",
      "txt_not_set": "not set",
      "txt_no_shipper_linked_yet": "No shipper linked yet",
      "txt_no_consignee_linked_yet": "No consignee linked yet",
      "txt_package_contains_dangerous_goods": "This package contains dangerous goods",
      "txt_remarks": "Remarks",
      "txt_city": "City",
      "txt_pickup_and_delivery": "Pickup & delivery",
      "lbl_pickup_shipper_address": "Pickup / Shipper address",
      "lbl_delivery_consignee_address": "Delivery / Consignee address",
      "lbl_origin": "Origin",
      "lbl_destination": "Destination",
      "txt_total": "Total:",
      "txt_no_costs_yet": "No cost information is available for this booking yet."
    }
  },
  "shipments": {
    "txt_we_cant_find_shipment": "We can't find that shipment",
    "txt_try_changing_search_phrase": "Try changing your search phrase or check your filters.",
    "txt_shipments": "shipments",
    "txt_canceled": "Canceled",
    "txt_new_eta_is_delayed": "New ETA is at least 24 hours later than initially planned",
    "txt_new_eta_is_early": "New ETA is at least 24 hours earlier than initially planned",
    "txt_delayed": "Delayed",
    "txt_early": "Early",
    "txt_amount_of_containers": "Amount of containers:",
    "txt_containers": "Containers:",
    "txt_unknown": "Unknown",
    "txt_one_free_day_left": "There is only one free day left for Demurrage/Detention on at least one or more containers.",
    "txt_no_free_days_left": "There are no free days left for demurrage/detention on at least one or more containers.",
    "txt_arriving_today": "Arriving today",
    "lbl_routing_will_soon_be_available": "Routing will soon be available",
    "txt_no_information_found": "No information found",
    "txt_no_icon": "no icon",
    "txt_open_task": "You have {{count}} open task for this shipment",
    "txt_open_tasks": "You have {{count}} open tasks for this shipment",
    "txt_by": "by",
    "txt_on": "on",
    "txt_emission_data_available": "Emission data available for this Shipment.",
    "txt_calcualting": "Calculating...",
    "txt_emission_data_not_available": "Emission data is being calculated for this Shipment.",
    "txt_day_one": "{{count}} day",
    "txt_day_other": "{{count}} days",
    "txt_day_routing_one": "{{count}} day",
    "txt_day_routing_other": "{{count}} days",
    "txt_etd_diff_days": "ETD: {{date}} ({{diff}} days)",
    "txt_to_be_determined": "To be determined",
    "txt_eta_date_diff_days": "ETA: {{date}} ({{diff}} days)",
    "shipment_detail": {
      "lbl_tab_cargo": "Cargo",
      "lbl_tab_todo": "To Do List",
      "lbl_tab_documents": "Documents",
      "lbl_tab_costs": "Costs",
      "lbl_charge": "Charge",
      "lbl_description": "Description",
      "lbl_original_amount": "Original Amount",
      "lbl_conv_rate": "Conv. Rate",
      "lbl_invoice_amount": "Amount",
      "txt_subtotal": "Subtotal",
      "lbl_invoice": "Invoice",
      "cta_download": "Download",
      "txt_no_invoice_lines": "No invoices available for this shipment yet.",
      "txt_peppol_invoice_info": "The original invoice has been sent to your Peppol address. This invoice is for viewing purposes only.",
      "txt_invoice_disclaimer_demo": "This invoice is part of the demo environment, and may not reflect the actual charges for your shipment or real world scenarios.",
      "txt_invoice_recently_uploaded": "Uploaded within the last {{hours}} hours",
      "txt_by_sender_on": "by {{sender}} on {{date}}",
      "txt_early": "Early",
      "txt_delayed": "Delayed",
      "txt_last_updated": "Last updated: {{date}}",
      "lbl_consolidated": "Consolidated",
      "txt_shipment_consolidated": "Shipment Consolidated",
      "txt_what_is_consolidated_shipment": "What is a consolidated shipment?",
      "lbl_consolidated_shipment_description": "A <strong>consolidated shipment</strong> combines multiple LCL shipments into one full container to optimize space, reduce costs, and improve efficiency. Once the container reaches its destination, the LCL shipments will be delivered to their final delivery address(es).",
      "txt_shipment_is_consolidated_with_other": "This shipment is consolidated with other shipments in container",
      "txt_in": "in",
      "txt_client_ref": "Client Ref",
      "txt_link_created_succesfully": "Your link has been created succesfully, you can now copy it.",
      "txt_shipment_is_shared": "Your shipment has been shared, we have sent an email to the provided addresses.",
      "txt_click_to_check_the_email": "Click to check the e-mail adresses this shipment is shared with",
      "txt_click_to_share_shipment": "Click to share this shipment",
      "txt_share_shipment": "Share Shipment",
      "lbl_shipment_shared_with": "This shipment is shared with the following e-mail addresses:",
      "cta_share": "Share",
      "txt_note": "Note:",
      "txt_by": "by",
      "txt_on": "on",
      "txt_expires": "Expires {{date}}",
      "txt_no_free_days_left": "There are no free days left for demurrage/detention on at least one or more containers.",
      "txt_revoke_access": "Revoke access",
      "txt_are_you_sure_revoke_access": "Are you sure you want to revoke access to this content?",
      "txt_link_copied": "Link copied",
      "txt_copy_link": "Copy link",
      "lbl_share_shipment_details": "Share shipment details effortlessly: Provide email addresses for us to send a public URL, or generate and share the link yourself. Access lasts up to 3 months.",
      "lbl_email_addresses": "Email addresses",
      "txt_invalid_email": "Invalid email",
      "alert_shipment_already_shared": "This shipment is already shared with:",
      "lbl_how_to_share": "How to share?",
      "cta_by_link": "by Link",
      "cta_by_mail": "by Mail",
      "txt_add_note": "Add a note to the email (optional)",
      "lbl_note": "Note",
      "cta_open_report": "open report",
      "alert_emission_report_available": "Emission report available for this Shipment.",
      "alert_emission_report_not_available": "No emission report available for this Shipment yet.",
      "txt_calculating_emission": "We are currently calculating the emission for this Shipment, please check back later.",
      "alert_emission_report_body": "The total emission for this Shipment is: {{total}} kg CO2, open the report for more details.",
      "txt_co2_total": "CO<sub>2</sub>e total",
      "txt_emission": "Emission",
      "txt_distance": "Distance",
      "lbl_transit_hub": "Transit Hub",
      "txt_to_city": "to",
      "txt_emission_report": "Emission Report",
      "txt_emission_report_description": "Emissions are calculated only for the transportation managed by Rotra under the agreed incoterm.",
      "txt_emission_report_not_available": "No emissions data available for this shipment.",
      "txt_description_emission_report_not_available": "Based on the incoterm, Rotra managed no transport for this shipment. Therefore the emission is set at zero by default.",
      "txt_emission_glec_framework": "Emissions data provided is based on the GLEC framework. Accuracy may vary; users are encouraged to consult experts for specific applications. For more information about the GLEC framework consult:",
      "txt_any_questions": "If you have any questions, please don't hesitate to contact us.",
      "txt_location_info": "Location provided is based on the postal code of the address.",
      "txt_from": "From:",
      "txt_to": "To:",
      "txt_total": "Total:",
      "cta_smart_freight_centre": "Smart Freight Centre",
      "txt_one_free_day_left": "There is only one free day left for Demurrage/Detention on at least one or more containers.",
      "cta_view": "view",
      "txt_less": "less",
      "txt_more": "more",
      "alert_track_and_trace_unavailable": "Ship tracking on map is currently unavailable.",
      "txt_port_of_loading": "Port of loading",
      "txt_port_of_discharge": "Port of discharge",
      "txt_location_update": "Location update",
      "txt_current_location": "Current location",
      "txt_current_location_delayed": "Current location delayed",
      "txt_origin": "Origin",
      "txt_destination": "Destination",
      "txt_press_for_legend": "Press for legend",
      "txt_legend": "Legend",
      "txt_transit": "Transit",
      "txt_flight_nr": "Flight Nr",
      "txt_vessel": "Vessel",
      "txt_airline": "Airline",
      "txt_carrier": "Carrier",
      "lbl_shipper": "Shipper",
      "lbl_bill_of_lading": "Bill of Lading",
      "txt_master": "Master:",
      "txt_house": "House:",
      "lbl_consignee": "Consignee",
      "cta_view_sale": "View",
      "txt_contract": "contract",
      "txt_quote": "quote",
      "txt_created_from": "Created from",
      "txt_goods": "Goods",
      "txt_transport": "Transport",
      "txt_no_containers": "This shipment doesn't have any containers yet",
      "txt_cargo_id": "Cargo ID",
      "txt_container_no": "Container No.",
      "txt_packages_from": "Packages from",
      "txt_total_volume": "Total volume",
      "txt_marks_and_numbers": "Marks and numbers",
      "lbl_no_free_days_for_container": "There are no free days of demurrage/detention for this container",
      "lbl_container_incurred": "This container incurred dem/det charges",
      "alert_timezone_info": "Demurrage & detention times are shown in CET time. Your time zone is {{timezone}}, which is {{diff}} hour{{plural}} {{direction}} of CET.",
      "txt_free_days_demurrage_notice": "Free days start counting when the container arrives at the port of discharge.<1/>Demurrage starts once all of the free days have been used.",
      "txt_demurrage_notice": "Demurrage starts on {{startDate}} once all the free days have been used.<0/>Counting of the days ends when the container leaves the terminal.",
      "txt_demurrage_started": "Demurrage started on {{startDate}}.<0/>Counting of the days ends when the container leaves the terminal.",
      "txt_demurrage_summary": "{{totalDays}} days were used, <0>{{daysOverdue}} {{dayLabel}}</0> of which included demurrage charges.<1/>Counting ended when the container left the terminal on {{endDate}}.",
      "txt_free_days_detention_notice": "Free days start counting when the container leaves the terminal.<1/>Detention starts once all of the free days have been used.",
      "txt_detention_starts_notice": "Detention starts on {{startDate}} once all the free days have been used.<1/>Counting of the days ends when the container is returned empty.",
      "txt_detention_started_notice": "Detention started on {{startDate}}.<1/>Counting of the days ends when the container is returned empty.",
      "txt_detention_summary": "{{totalDays}} days were used, <0>{{daysOverdue}} {{dayLabel}}</0> of which included detention charges.<1/>Counting ended when the container was returned empty on {{endDate}}.",
      "txt_free_days_both_notice": "Free days start counting when the container arrives at the port of discharge.<0/>Demurrage and detention starts once all of the free days have been used.",
      "txt_both_started_notice": "Demurrage and detention starts on {{startDate}} once all the free days have been used.<0/>Counting of the days ends when the container is returned empty.",
      "txt_both_started_notice_past": "Demurrage and detention started on {{startDate}}.<0/>Counting of the days ends when the container is returned empty.",
      "txt_both_summary": "{{totalDays}} days were used, <0>{{daysOverdue}} {{dayLabel}}</0> of which included demurrage and detention charges.<1/>Counting ended when the container was returned empty on {{endDate}}.",
      "txt_only_business_days": "<0/>Only business days are used for calculating free days",
      "txt_weekend": "Weekend",
      "lbl_type_cannot_be_calculated": "{{typeLabel}} cannot be calculated at the moment",
      "txt_no_packages_yet": "This shipment does not have any packages yet",
      "txt_no_cargo_yet": "This container does not have any cargo yet",
      "txt_cargo_from_consolidated_shipments": "Cargo from consolidated shipments",
      "alert_no_transport_yet": "This shipment doesn't have any transport yet",
      "txt_inland_transport_at_origin": "Inland transport at origin",
      "txt_container_number": "Container Nr",
      "txt_pickup_address": "Pickup address",
      "txt_pickup_date": "Pickup date",
      "txt_status": "Status",
      "alert_container_no_transport_yet": "This container doesn't have a transport yet at the {{segmentType}}",
      "txt_delivery_address": "Delivery Address",
      "txt_reference": "Reference",
      "txt_remark": "Remark: {{remark}}",
      "lbl_remark": "Remark",
      "txt_inland_transport_at_destination": "Inland transport at destination",
      "txt_goods_description": "Goods Description",
      "txt_width": "Width",
      "txt_length": "Length",
      "txt_weight": "Weight",
      "txt_height": "Height",
      "txt_volume": "Volume",
      "txt_no_transport_yet": "This shipment doesn't have any transport yet",
      "txt_delivery_date": "Delivery date",
      "txt_no_transport_yet_for_cargo": "This cargo doesn't have a transport yet at the {{segmentType}}",
      "txt_no_cargo_yet_for_shipment": "This shipment doesn't have any cargo yet",
      "txt_no_packages_yet_for_cargo": "This cargo doesn't have any packages yet",
      "txt_no_cargo": "This cargo doesn't have a transport yet",
      "txt_to_do_list": "To Do List",
      "txt_to_do": "To Do",
      "txt_done": "Done",
      "txt_no_tasks_left_for_this_shipment": "You don't have any tasks left to do for this shipment",
      "txt_no_completed_tasks_left_for_this_shipment": "You don't have any completed tasks for this shipment",
      "txt_succesfully_reopened_this_task": "You have succesfully re-openend this task.",
      "txt_succesfully_completed_task": "You have succesfully completed the task: {{task}}.",
      "txt_due": "Due",
      "txt_days_left_one": "{{count}} day left",
      "txt_days_left_other": "{{count}} days left",
      "txt_today": "Today",
      "txt_deadline_not_available": "Deadline not available",
      "txt_days_late_one": "{{count}} day late",
      "txt_days_late_other": "{{count}} days late",
      "txt_reopened_by_rotra": "Reopened by Rotra: {{remark}}",
      "txt_completed_on": "Completed on {{date}} by",
      "txt_upload": "Upload",
      "txt_upload_file": "Upload file",
      "cta_complete": "Complete",
      "cta_mark_as_done": "Mark as done",
      "cta_reopen": "Re-open",
      "cta_mark_as_to_do": "Mark as to do",
      "txt_view_task": "View task",
      "cta_more": "+ {{count}} more",
      "cta_show_less": "Show less",
      "cta_more_documents_one": "+ {{count}} more document",
      "cta_more_documents_other": "+ {{count}} more documents",
      "cta_show_less_documents": "Show fewer documents",
      "txt_documents": "Documents {{count}}",
      "lbl_shipment_documents": "Shipment documents",
      "lbl_uploaded_documents": "Uploaded documents",
      "txt_uploaded_on": "Uploaded on {{date}} by",
      "txt_container": "Container",
      "txt_no_shipment_documents_added": "No shipment documents added or accepted by Rotra yet.",
      "txt_upload_your_documents_to_see_them": "Upload your documents to see them here.",
      "txt_documents_are_uploaded": "Documents are successfully uploaded!",
      "txt_click_here_to_select_documents": "Click here to select documents or drag a file here to upload",
      "txt_maximum_upload_file": "Maximum upload file size: 10MB",
      "txt_failed_to_upload_documents": "Failed to upload the following documents:",
      "txt_failed_because": "{{file}} failed because",
      "txt_select_document_type": "Select a document type",
      "lbl_document_type": "Document Type",
      "txt_select_all": "Select All",
      "txt_available_containers": "Available containers",
      "txt_awaiting_container_numbers": "Awaiting container numbers",
      "txt_upload_documents_to_see_them_here": "Upload documents to see them here",
      "txt_please_select_document_type": "Please select a document type for each document to continue",
      "txt_want_to_leave": "Are you sure you want to leave?",
      "cta_leave_shipment": "Yes, leave shipment",
      "cta_continue_with_shipment": "Continue with shipment",
      "txt_description_uploaded_documents": "Your documents are not yet uploaded to this shipment. Press the Save button in the document region to complete the upload. If you leave now, your documents will not have been uploaded.",
      "txt_file_is_too_big": "the file is too big, the maximum size is 10MB.",
      "txt_unsupported_file_type": "unsupported file type.",
      "txt_invalid_character": "the filename contains an invalid character. Please rename the file and try again.",
      "txt_error_occurred": "an unexpected error occurred.",
      "txt_cargo_description": "Cargo description:",
      "messages": {
        "txt_messages": "Messages",
        "cta_minimize": "Minimize",
        "txt_no_messages_yet": "There are no messages yet.",
        "txt_messages_failed_to_load": "Messages failed to load.",
        "cta_scroll_to_new_messages": "Scroll to new messages",
        "txt_new_messages_count_one": "{{count}} new message",
        "txt_new_messages_count_other": "{{count}} new messages"
      }
    },
    "txt_by_sender_on": "by {{sender}} on {{date}}"
  },
  "rotra_map": {
    "txt_cluster_title": "Cluster of {{count}} shipments",
    "cta_exit_fullscreen": "Exit fullscreen",
    "cta_enter_fullscreen": "Enter fullscreen",
    "txt_couldnt_load_google_maps": "This page couldn't load Google Maps correctly."
  },
  "address_book_page": {
    "txt_successfully_deleted_address": "Successfully deleted address",
    "lbl_delete_address_title": "Delete {{name}}",
    "txt_delete_address_confirm": "Are you sure you want to delete this address for {{name}}? This action cannot be undone.",
    "txt_address_book": "Address book",
    "cta_add_new_address": "Add new address",
    "txt_no_addresses_found": "No addresses found.",
    "txt_addresses": "addresses",
    "cta_view_all_contacts": "View all {{count}} contacts",
    "cta_hide_contacts": "Hide contacts",
    "txt_no_contact_person": "No contact person",
    "detail": {
      "txt_successfully_saved_address": "Successfully saved address",
      "txt_successfully_updated_address": "Successfully updated address",
      "txt_new_address": "New address",
      "txt_edit_address": "Edit address",
      "txt_view_address": "View address",
      "txt_no_contact_person": "No contact person",
      "txt_created": "Created: {{date}}",
      "txt_updated": "Updated: {{date}}",
      "txt_address_book_item_not_found": "Address book item not found.",
      "txt_company": "Company",
      "lbl_company_name": "Company name",
      "lbl_street_address": "Street address",
      "lbl_street_address2": "Street address 2",
      "lbl_country": "Country",
      "lbl_postal_code": "Postal code",
      "txt_city": "City",
      "txt_contacts": "Contacts",
      "lbl_contact_person_name": "Contact person name",
      "lbl_email": "E-mail",
      "lbl_phone": "Phone",
      "cta_delete_contact": "Delete contact",
      "cta_add_another_contact_person": "Add another contact person",
      "cta_add_contact_person": "Add contact person",
      "txt_saving": "Saving",
      "txt_duplicate_company_address": "This company and address already exist — select it from the suggestions to add a contact there instead",
      "txt_invalid_company_name": "Please enter a valid company name",
      "txt_invalid_street_address": "Please enter a valid street address",
      "txt_invalid_city": "Please enter a valid city",
      "txt_invalid_name": "Please enter a valid name",
      "lbl_netherlands": "Netherlands",
      "lbl_belgium": "Belgium",
      "lbl_germany": "Germany"
    }
  },
  "organizations": {
    "lbl_add_more": "Add more",
    "lbl_team": "Team",
    "lbl_about": "About",
    "lbl_api_keys": "API keys",
    "lbl_webhooks": "Webhooks",
    "lbl_select_organization": "Select organization",
    "lbl_city": "City",
    "lbl_vat_number": "VAT number",
    "lbl_account_number": "Account number",
    "cta_add_user": "Add user",
    "txt_actions": "Actions",
    "txt_cannot_remove_admin": "Cannot remove admin, please contact: cs@rotra.nl",
    "txt_activation_pending": "Activation Pending",
    "txt_admin": "Admin",
    "txt_user": "User",
    "cta_remove": "Remove",
    "txt_could_not_invite_users": "Could not invite all users",
    "txt_users_invited_successfully": "Users invited successfully",
    "txt_add_users": "Add users to the",
    "txt_organization": "organization",
    "cta_invite_users": "Invite {{count}} user",
    "cta_invite_users_plural": "Invite {{count}} users",
    "cta_invite": "Invite",
    "txt_active_users": "Active users",
    "txt_pending_users": "Pending users",
    "txt_no_users_found": "No users found, please enter an email address",
    "lbl_email_address_or_name": "Email address or name",
    "cta_add_another_user": "+ Add another user",
    "lbl_user_already_in_organization": "User already in organization",
    "lbl_user_already_in_list_to_invite": "User already in list to invite",
    "lbl_last_login": "Last Login",
    "lbl_role": "Role",
    "lbl_name": "Name",
    "alert_take_control_of_your_data": "Take control of your data: Manage users and enhance security with myRotra's User Management",
    "alert_manage_your_own_users": "From now on it's possible to manage your own users on myRotra.",
    "cta_read_less": "Read less",
    "cta_read_more": "Read more",
    "txt_new_powerful_feature": "We are excited to announce a powerful new feature on myRotra that puts you in control of your data and enhances the security of your organization. Introducing User Management, a streamlined solution that allows you to manage your users effortlessly.",
    "txt_whats_new": "What's new?",
    "txt_oversee_and_control_user_access": "With our redesigned User Management solution, you have the ability to oversee and control user access to your data. Here's what you can expect:",
    "txt_manage_users": "Manage users",
    "txt_protect_your_data": "Protect your data",
    "txt_more_insights": "More insights",
    "txt_enchanced_effiency": "Enhanced effiency",
    "txt_one_thing_we_need": "There is just one thing we need",
    "txt_need_to_be_admin": "To manage users on myRotra, you need to be an admin. Currently, there is no admin configured for this organization. We kindly request that you take action by reaching out to your account manager or our Customer Success team to provide us with one or more individuals as admin for your organization.",
    "cta_contact_us_now": "Contact us now",
    "txt_contact_rotra": "Contact Rotra",
    "txt_about": "About",
    "txt_legal_name": "Legal name",
    "txt_account_no": "Account no.",
    "txt_address": "Address",
    "txt_vat": "Vat no.",
    "txt_api_keys": "API Keys",
    "txt_loading_keys": "Loading keys...",
    "txt_no_active_api_keys_found": "No active API keys found",
    "txt_created": "Created:",
    "txt_expired": "Expired:",
    "txt_primary_key": "Primary Key",
    "txt_secondary_key": "Secondary Key",
    "txt_copied": "Copied!",
    "txt_copy_to_clipboard": "Copy to clipboard",
    "txt_hide_key": "Hide key",
    "txt_show_key": "Show key",
    "alert_only_administrator_view_api_keys": "Only your organization administrator can view API keys. Please contact them to obtain API access.",
    "alert_api_keys_integrate_rotra_service": "API keys allow you to integrate Rotra's services directly into your systems.",
    "lbl_active": "Active",
    "lbl_expired": "Expired",
    "txt_apikey_expired": "API key has expired and can no longer be used",
    "lbl_suspended": "Suspended",
    "txt_apikey_suspended": "API key has been suspended and cannot be used",
    "lbl_pending": "Pending",
    "txt_apikey_pending": "API key request is pending approval",
    "lbl_rejected": "Rejected",
    "txt_apikey_rejected": "API key request has been rejected",
    "lbl_cancelled": "Cancelled",
    "txt_apikey_cancelled": "API key has been cancelled",
    "lbl_unknown": "Unknown",
    "txt_apikey_unknown": "Unknown API key state",
    "txt_apikey_dummy": "Production API Key (DUMMY)",
    "txt_apikey_pending_dummy": "Pending Approval Key (DUMMY)",
    "txt_apikey_expired_dummy": "Expired Development Key (DUMMY)",
    "txt_apikey_suspended_dummy": "Suspended Test Key (DUMMY)",
    "txt_need_access_to_more_organizations": "Need access to more organizations on myRotra?",
    "txt_discover_possibilities": "Discover the possibilities of connecting multiple businesses to <strong>one</strong> myRotra account",
    "txt_view_everything_using_one_account": "View everything using only one account",
    "txt_focus_on_what_is_important": "Focus on what is important and urgent",
    "txt_spend_less_time": "Spend less time staying up to date",
    "txt_coordinationg_work_across_multiple_businesses": "Coordinating work across multiple businesses is hard. myRotra makes it easier.",
    "txt_using_myrotra": "Using myRotra with multiple Organizations allows you to work across different businesses (<i>legal entities</i>).<br />It makes collaboration easy and integrates all your information in the same portal.",
    "txt_need_more_information": "Need more information?",
    "txt_display_name": "Customize your Organization's display name on myRotra",
    "txt_display_name_subtitle": "Make it easy for your team to find this organization",
    "lbl_display_name": "Display name",
    "txt_displayed_name_updated_successfully": "Display name updated successfully",
    "txt_change_affects_all_users": "Change affects all users in your team. Use an easy identifiable name",
    "txt_all_team_members_see_display_name": "All team members see the same display name",
    "txt_visual_change_notice": "Change is only visual.<br />It does <strong>not</strong> update your legal information in our systems",
    "txt_only_admins_can_change": "Only admins can change the display name",
    "txt_account_number": "Account number: {{clientId}}",
    "txt_admin_updated_display_name": "Your organization's admin has updated the display name",
    "txt_change_display_name": "Change your organization's display name",
    "txt_admin_updated_display_name_subtitle": "Instead of the legal name, the display name of your organization is presented, simplifying organization identification on myRotra.",
    "alert_display_name_preview": "Always use your account number <strong>({{clientId}})</strong> of your organization or the Rotra reference when contacting Rotra.",
    "txt_from": "From",
    "txt_to": "To",
    "txt_get_api_access": "To get API access for your organization, please contact",
    "txt_api_access_allows_you": "API access allows you to integrate Rotra's services directly into your systems.",
    "txt_production_api_key": "This is your production API key for the rotraNext API.",
    "txt_disabled_because_the_form_is_read_only": "Disabled because the form is read-only",
    "txt_active_organizations": "Active organizations",
    "txt_obsolete_organizations": "Obsolete organizations",
    "webhooks": {
      "txt_loading_webhooks": "Loading Webhooks...",
      "alert_delete_error": "We were unable to delete the webhook registration at the moment. Please try again later.",
      "warning_alert": {
        "alert_title": "Important",
        "alert_message": "Webhook secrets can only be viewed <strong>once</strong>—immediately after creating a new webhook or regenerating a secret. Be sure to store them securely."
      },
      "txt_not_admin": "Only your organization administrator can view Webhooks. Please contact them to obtain Webhook access.",
      "txt_subtitle": "Configure webhook endpoints to receive real-time event notifications.",
      "info_alert": {
        "alert_title": "Webhook Delivery & Format",
        "alert_message": "Webhooks contain only the entity ID and minimal metadata. You'll need to make an API request using the entity_callback_url to retrieve complete details. If delivery fails, our system retries with exponential backoff up to 5 times.",
        "txt_example_payload": "Example Payload"
      },
      "cta_create_webhook": "Create new webhook",
      "card": {
        "txt_created": "Created",
        "txt_last_modified": "Last modified",
        "txt_info_tooltip": "Each webhook request includes an HMAC signature for verification. Click to learn more.",
        "info_dialog": {
          "txt_subtitle": "Understanding and Verifying Webhook Authenticity",
          "txt_body": "To ensure authenticity, all webhook requests include an HMAC signature. You should verify this signature before processing the event using the webhook secret and webhook event payload (without the secret).",
          "txt_learn": "Learn how to verify signatures.",
          "cta_close": "Close"
        },
        "cta_delete": "Delete Webhook",
        "txt_title": "Edit Event Types",
        "cta_copy": "Copy to clipboard",
        "txt_copied": "Copied!",
        "txt_secret_message": "Can only display newly created secrets",
        "cta_show": "Show Secret",
        "cta_hide": "Hide Secret",
        "cta_regenerate": "Regenerate secret"
      },
      "create_modal": {
        "txt_title": "Create New Webhook",
        "txt_description": "Your endpoint must accept HTTP POST requests to receive events.",
        "cta_cancel": "Cancel",
        "cta_create": "Create webhook",
        "alert_url_error": "Please enter a valid URL including http:// or https://."
      },
      "edit_modal": {
        "txt_title": "Edit Event Types",
        "cta_cancel": "Cancel",
        "cta_save": "Save changes"
      },
      "regenerate_modal": {
        "txt_title": "Regenerate Secret Key",
        "txt_message": "Are you sure you want to regenerate the secret key for <strong>{{ webhookId }}</strong>?",
        "cta_cancel": "Cancel",
        "cta_regenerate": "Regenerate key",
        "alert_title": "Important Security Notice",
        "alert_body": "Regenerating the secret key will invalidate the current key. You will need to update your webhook endpoint to use the new key."
      },
      "delete_modal": {
        "cta_delete": "Delete Webhook",
        "txt_message": "Please type <strong>{{ confirmationValue }}</strong> to confirm deletion.",
        "cta_cancel": "Cancel",
        "alert_title": "Warning: This action cannot be undone.",
        "alert_body": "You are about to delete the webhook <strong>{{ webhookId }}</strong>. This will immediately stop all event notifications to this endpoint.",
        "txt_confirmation_value": "DELETE"
      },
      "event_selector": {
        "txt_event_type_description": "Choose events to receive notifications for.",
        "lbl_event_type": "Search events...",
        "ph_search_event": "Search or select events",
        "txt_common_events": "Common events"
      },
      "empty_state": {
        "txt_title": "No Webhooks configured",
        "txt_subtitle": "Webhooks allow your applications to receive real-time notifications when events occur in your account.",
        "cta_create": "Create your first webhook"
      }
    }
  },
  "tasks": {
    "lbl_to_do": "To Do's",
    "txt_to_do_list": "To Do List",
    "txt_to_do": "To Do",
    "lbl_for_you": "For you",
    "lbl_all": "All",
    "txt_no_tasks_for_shipments_you_watching": "You do not have any tasks right now for shipments you are watching",
    "txt_tasks": "tasks",
    "txt_no_tasks_by_selected_filters": "We can not find any open tasks for the selected filters",
    "txt_no_tasks_right_now": "You do not have any tasks right now",
    "lbl_task": "Task",
    "txt_client_reference": "Client Reference",
    "txt_open_task_one": "{{count}} task",
    "txt_open_task_other": "{{count}} tasks",
    "txt_completed_task": "You have succesfully completed the task: {{taskName}}",
    "txt_succesfully_uploaded_documents": "Succesfully uploaded documents, however we could not complete the task. Please try again.",
    "txt_upload_and_complete_files": "Submitting will upload the following files and mark this task as completed.",
    "txt_save_and_complete": "Save & complete",
    "txt_no_documents_to_upload": "No documents uploaded yet",
    "cta_upload_more": "+ Upload more",
    "txt_file_is_too_big": "The file is too big, the maximum size is 10MB.",
    "txt_unsupported_file_type": "unsupported file type.",
    "txt_filename_contains_invalid_character": "The filename contains an invalid character. Please rename the file and try again.",
    "txt_unexpected_error": "An unexpected error occurred."
  },
  "messages": {
    "txt_messages": "Messages",
    "lbl_for_you": "For you",
    "lbl_all": "All",
    "txt_messages_list": "messages",
    "txt_change_filters_cant_find_messages": "We can not find that message try to change your filters",
    "txt_not_received_any_messages": "You have not yet received any messages for Quote requests, Spot rates and Shipments you are watching",
    "txt_no_messages": "You have not yet received any messages",
    "lbl_only_show_unread": "Only show unread",
    "txt_marking_as_read": "Marking as read...",
    "cta_view_conversation": "View conversation",
    "txt_from": "From: {{name}}",
    "cta_mark_as_read": "Mark as read",
    "cta_mark_amount_as_read": "Mark {{count}} as read",
    "cta_mark_all_as_read": "Mark all as read",
    "txt_client_reference": "Client Reference",
    "txt_quotation": "Quotation"
  },
  "notifications": {
    "txt_notifications": "Notifications",
    "lbl_email": "Email",
    "lbl_notification_center": "Notification Center",
    "txt_all_labels": "All {{label}}",
    "txt_enabled_notification_one": "+{{count}} other",
    "txt_enabled_notification_other": "+{{count}} others",
    "cta_preferences": "Preferences",
    "txt_notification_preferences": "Notification preferences",
    "alert_too_many_notifications": "Receiving too many notifications?",
    "txt_enable_email_and_portal": "You can now enable email- and portal notifications for watched Shipments only, this can drastically reduce the number of notifications you receive.",
    "txt_note_notifications": "<strong>Note:</strong> You will still receive notifications related to quotes, contracts, and when a shipment is created.",
    "txt_receive_notifications_for_watched_shipments": "Only receive notifications for watched Shipments:",
    "txt_receive_notifications_for_new_quotes_and_messages_within_these_quotes": "Receive notifications for new quotes and messages within these quotes",
    "txt_new_quote": "New quote",
    "txt_receive_update_when_quote_is_available": "Receive an update when a new quote is available",
    "txt_new_message": "New message",
    "txt_receive_update_when_new_message_is_available": "Receive an update when a new message within the quote is available",
    "txt_receive_notifications_regarding_your_contracts": "Receive notifications regarding your contracts",
    "txt_new_contract": "New contract",
    "txt_receive_update_when_new_contract_is_available": "Receive an update when a new contract is available",
    "txt_booking_statuses": "Booking statuses",
    "txt_receive_notifications_on_status_changes": "Receive notifications on status changes in your bookings",
    "txt_canceled": "Canceled",
    "txt_receive_update_when_booking_is_canceled": "Receive an update when a booking is canceled",
    "txt_reopened": "Reopened",
    "txt_receive_update_when_booking_is_reopened": "Receive an update when a booking is reopened",
    "txt_receive_notifications_on_certain_events_within_your_shipments": "Receive notifications on certain events within your shipments",
    "txt_receive_update_new_message_within_shipment": "Receive an update when a new message within the shipment is available for your shipment",
    "txt_new_task": "New task",
    "txt_receive_update_when_new_task_is_available": "Receive an update when a new task is available for your shipment",
    "txt_schedule_changes": "Schedule changes",
    "txt_receive_update_when_schedule_changes_in_your_shipment": "Receive an update when there's a schedule change in your shipment",
    "txt_new_document_available": "New document available",
    "txt_receive_update_when_document_is_available": "Receive an update when a document is available for your shipment",
    "txt_receive_notification_when_document_becomes_availabe_for_shipment": "You receive a notification when a document becomes available for your shipment. Select the specific document types you wish to receive these notifications for:",
    "txt_status_change": "Status change",
    "txt_receive_update_when_status_changes_in_your_shipment": "Receive an update when there's a status change in your shipment",
    "txt_receive_notification_when_status_of_shipment_changes": "You receive a notification when a status of your shipment changes. Select which status changes you wish to receive these notifications for:",
    "lbl_documents": "documents",
    "lbl_statuses": "statuses",
    "txt_pickup_date_changes": "Pickup date changes",
    "txt_receive_an_update_when_there_is_new_pickup_date": "Receive an update when there's a new pickup date for your shipment",
    "txt_delivery_date_changes": "Delivery date changes",
    "txt_receive_update_when_new_delivery_date_for_your_shipment": "Receive an update when there's a new delivery date for your shipment",
    "whats_new": {
      "txt_whats_new": "What's new",
      "txt_changelog": "Changelog",
      "txt_whats_new_at_myrotra": "What's new at MyRotra?",
      "txt_release_notes": "Release notes",
      "txt_nothing_new": "Nothing new to show",
      "txt_release_notes_will_be_available": "The Release notes will be displayed on this page once they become available.",
      "txt_published_on": "Published on {{date}}",
      "txt_more_information": "Having trouble or want more information?<br />Get in touch using the button below:<br />",
      "txt_release_note_not_found": "Release Note item not found.",
      "teaser": {
        "txt_published_on": "Published on {{date}}"
      }
    },
    "cta_dismiss_all": "Dismiss all",
    "txt_no_notifications_right_now": "No notifications right now",
    "txt_booking_is_canceled": "Booking <i>{{ref}}</i> is canceled.",
    "txt_booking_is_reopened": "Booking <i>{{ref}}</i> is reopened and will soon be processed.",
    "txt_booking_status_update": "Booking <i>{{ref}}</i> received a status update.",
    "cta_click_for_more_details": "{{date}}, click for more details",
    "txt_shipment_confirmed": "Booking for shipment <i>{{ref}}</i> is confirmed.",
    "txt_shipment_departed": "Shipment <i>{{ref}}</i> is departed.",
    "txt_shipment_arrived": "Shipment <i>{{ref}}</i> is arrived.",
    "txt_shipment_delivered": "Shipment <i>{{ref}}</i> is delivered.",
    "txt_shipment_canceled": "Shipment <i>{{ref}}</i> is canceled.",
    "txt_shipment_is_released_third_party": "Shipment <i>{{ref}}</i> is released third party.",
    "txt_shipment_status_update": "Shipment <i>{{ref}}</i> received a status update.",
    "txt_eta_now_as_planned": "Shipment <i>{{ref}}</i> has a new ETA: {{date}} (as originally planned)",
    "txt_eta_later": "Shipment <i>{{ref}}</i> has a new ETA: {{date}} ({{timeDiff}} later than the previous ETA)",
    "txt_eta_earlier": "Shipment <i>{{ref}}</i> has a new ETA: {{date}} ({{timeDiff}} earlier than previous ETA)",
    "txt_eta_no_longer_delayed": "Shipment <i>{{ref}}</i> is no longer delayed! Current ETA: {{date}}",
    "txt_eta_generic": "Shipment <i>{{ref}}</i> has a new ETA: {{date}}",
    "txt_shipment_created_by_rotra": "Shipment <i>{{ref}}</i> is created by Rotra.",
    "txt_new_contract_available": "A new contract with the reference <i>{{ref}}</i> is available.",
    "txt_attachment_added": "{{type}} is attached to shipment <i>{{ref}}</i>.",
    "txt_new_quote_with_ref": "A new quote with reference <i>{{ref}}</i> is available. You can view and book this quote now.",
    "txt_new_quote_no_ref": "A new quote is available. You can view and book this quote now.",
    "txt_sub_picked_up_actual": "Cargo for shipment <i>{{ref}}</i> has been picked up.",
    "txt_sub_picked_up_estimated": "New estimated pickup date for shipment <i>{{ref}}</i>.",
    "txt_sub_picked_up_planned": "Planned pickup date for shipment <i>{{ref}}</i> is determined.",
    "txt_sub_delivery_estimated": "New estimated delivery date for shipment <i>{{ref}}</i>.",
    "txt_sub_delivery_planned": "Planned delivery date for shipment <i>{{ref}}</i> is determined.",
    "txt_sub_default": "Shipment <i>{{ref}}</i> received a sub-status update."
  },
  "settings": {
    "txt_settings": "Settings",
    "txt_profile": "Profile",
    "txt_first_name": "First name",
    "txt_last_name": "Last name",
    "txt_change_password": "Change password",
    "txt_email_instructions": "When pressing this button, an email with instructions will be sent.",
    "txt_profile_is_complete": "Profile is {{percentage}}% complete",
    "txt_open_tasks": "Open tasks",
    "txt_configure": "Configure {{key}}",
    "txt_configure_profile_picture": "Configure profile picture",
    "txt_sent_email_to_reset_your_password": "We've just sent you an email to reset your password.",
    "preferences": {
      "txt_user_preferences": "User Preferences",
      "txt_auto_translate": "Auto translate",
      "txt_auto_translate_description": "Automatically translate messages and release notes to your preferred language",
      "txt_language_selection": "Language",
      "txt_default_translation_language": "Default translation language",
      "txt_default_translation_language_description": "Select the default language for translations",
      "txt_measurement_system": "Default measurement system",
      "txt_measurement_system_description": "Select the default measurement system used throughout myRotra",
      "txt_metric": "Metric",
      "txt_imperial": "Imperial"
    }
  },
  "api": {
    "txt_api_documentation": "API Documentation",
    "txt_integrate_all_realtime_shipment_information": "Integrate all real-time shipment information into your own ERP system",
    "txt_work_from_one_system": "Work from a single system",
    "txt_real_time_status_information_available": "Real-time status information available for all colleagues and departments",
    "txt_online_convenience_for_greater_efficiency": "Online convenience for greater efficiency and time savings",
    "cta_view_documentation": "View documentation"
  },
  "profile_menu": {
    "txt_light_mode": "Light Mode",
    "txt_dark_mode": "Dark Mode",
    "txt_auto_system_default": "Auto (System Default)",
    "txt_settings": "Settings",
    "txt_theme": "Theme",
    "txt_logout": "Log out"
  },
  "single_sales_channel": {
    "lbl_general": "General",
    "lbl_cargo": "Cargo",
    "lbl_shipper_and_consignee": "Shipper & Consignee",
    "lbl_finalize": "Finalize",
    "lbl_finalize_and_submit": "Finalize & Submit",
    "txt_general_charges": "General charges",
    "txt_total": "Total",
    "lbl_use_edit_button_to_complete_this_cargo": "Use the edit button on the right to complete this cargo",
    "txt_booking_in_progress_would_you_like_resume_it": "You have a booking in progress. Would you like to resume it?",
    "cta_no_start_new": "No, start new",
    "cta_yes_resume": "Yes, resume",
    "txt_that_our_bad": "Oops, that's our bad",
    "txt_something_went_wrong": "We're not exactly sure what happened, but something went wrong. If you need immediate help, contact us by using the 'Support' button on the bottom left.",
    "txt_loading_text_one": "Searching the skies and roads for the perfect routes...",
    "txt_loading_text_two": "Sit tight, we're almost there! 🌐🚗🛫",
    "cta_continue_without_rate": "Continue without rate",
    "txt_continue_without_rate": "Continue without rate",
    "txt_continue_without_rate_for_ocean_freight": "Continue without rate for Ocean Freight",
    "txt_or": "or",
    "txt_request_a_quote": "Request a quote",
    "lbl_you_are_about_to_continue_this_booking_without_a_rate": "You are about to continue this booking without a rate. Are you sure you want to continue?",
    "alert_continue_without_rate": "<strong>Warning:</strong> You are about to continue this booking without a rate. This functionality is only available for Ocean freight.",
    "lbl_i_want_to_continue_without_a_rate": "I confirm that I want to continue without a rate",
    "lbl_i_want_to_continue_without_a_rate_for_ocean_freight": "I confirm that I want to continue without a rate for Ocean freight",
    "cta_submit_booking": "Submit Booking",
    "cta_reset": "Reset",
    "txt_reset_all_fields": "Are you sure you want to reset all fields?",
    "txt_booking_has_not_been_submitted_yet": "Your booking has not been submitted yet. Would you like to continue?",
    "cta_dismiss": "Dismiss",
    "txt_we_filled_in_most_cargo_fields_based_on_your_quote": "We filled in most cargo fields based on your quote, please complete the cargo below to continue your booking.",
    "txt_please_note_that_modifying_cargo": "Please note that modifying the cargo may lead to a price adjustment.",
    "cta_add_container": "Add Container",
    "cta_add_cargo": "Add cargo",
    "txt_select_organization_to_book_with": "Select the organization to book with.",
    "txt_results_will_reflect_its_agreement_with_rotra": "Results will reflect its agreement with Rotra.",
    "txt_changing_the_organization_will_reset_all_fields": "Changing the organization will reset all fields",
    "lbl_origin": "Origin *",
    "txt_where_will_your_cargo_depart_from": "Where will your cargo depart from?",
    "txt_pickup_address_may_be_added_in_a_later_step": "Pickup address may be added in a later step",
    "lbl_destination": "Destination *",
    "txt_where_will_your_cargo_arrive": "Where will your cargo arrive?",
    "txt_delivery_address_may_be_added_in_a_later_step": "Delivery address may be added in a later step",
    "txt_avilable_options": "Available Options",
    "txt_based_on_the_selected_routing_and_incoterm": "Based on the selected routing and incoterm we found the following options available for you",
    "txt_expires_in": "Option expires in {{days}} day",
    "alert_there_are_no_options_that_match_your_search": "There are no options that match your search",
    "alert_try_changing_your_input_to_see_results_or_request_a_new_quote": "Try changing your input to see results or request a new quote",
    "txt_any": "Any",
    "lbl_transit": "Transit",
    "txt_edit_cargo_details": "Edit cargo details",
    "txt_please_provide_cargo_details": "Please provide cargo details",
    "cta_update_cargo": "Update cargo",
    "alert_some_fields_are_pre_filled": "Some fields are pre-filled based on your {{entity}}, please complete the cargo details below to continue your booking.",
    "alert_quote": "quote",
    "alert_copied_container": "copied container",
    "txt_general_information": "General Information",
    "lbl_goods_description": "Goods description *",
    "lbl_select_container_type": "Select container type",
    "lbl_container_number": "Container number",
    "lbl_product_ready_date": "Product ready date",
    "lbl_weight_calculation_method": "Weight calculation method",
    "lbl_per_piece": "Per piece",
    "lbl_total": "Total",
    "alert_please_note_that_modifying_cargo": "Please note that modifying the cargo may lead to a price adjustment.",
    "txt_additional_information": "Additional information",
    "lbl_hs_code": "HS-code",
    "txt_hs_code_helper": "Please use only digits",
    "lbl_remarks": "Remarks",
    "txt_is_there_anything_that_we_forgot": "Is there anything that we forgot that might be helpful for us? Please let us know in this field",
    "lbl_weight_pc": "Weight/pc.",
    "lbl_total_weight": "Total weight",
    "lbl_volume_pc": "Volume/pc.",
    "lbl_dangerous_goods": "Dangerous goods",
    "cta_add_package": "Add package",
    "lbl_length_pc": "Length/pc.",
    "lbl_width_pc": "Width/pc.",
    "lbl_height_pc": "Height/pc.",
    "lbl_total_volume": "Total volume: {{volume}}",
    "lbl_cannot_find_what_you_need": "Cannot find what you need?",
    "txt_request_a_quote_to_receive_a_personalized_offer": "If so, request a quote to receive a personalized offer.",
    "txt_information_from_this_form_will_be_copied_to_the_quote_request_form": "The information from this form will be copied to the quote request form.",
    "alert_creating_booking_from_existing": "You are creating a booking from an existing {{entity}}",
    "txt_contract": "Contract",
    "txt_quote": "Quote",
    "cta_change_option": "Change Option",
    "txt_we_filled_in_some_information_based_on_your": "We filled in some information based on your {{entity}}. Pre-filled information is marked with a ",
    "txt_icon": " icon.",
    "txt_try_changing_your_input_to_see_results_or_request_a_new_quote": "Try changing your input to see results or request a new quote",
    "txt_no_description": "No description",
    "txt_what_do_you_want_ship": "What do you want to ship?",
    "lbl_shipper": "Shipper",
    "lbl_consignee": "Consignee",
    "lbl_pickup_address": "Pickup Address",
    "lbl_delivery_address": "Delivery Address",
    "lbl_service_property_is_the_same_as_entity_address": "{{service}} is the same as {{entity}} address",
    "txt_choose": "Choose {{label}}",
    "txt_optional_select": "Optional: select {{label}}",
    "lbl_quick_select": "Quick select:",
    "txt_shipper_and_consignee": "Shipper & Consignee",
    "txt_provide_the_shipping_and_consignee_for_your_cargo": "Please provide the shipper and consignee for your cargo",
    "txt_terms_and_conditions": "Terms & Conditions",
    "txt_thank_you_for_placing_a_booking_request_with_us": "Thank you for placing a booking request with us! Shipping details follow once your booking is confirmed by our operations.",
    "txt_finalize": "Finalize",
    "txt_please_enter_your_booking_reference": "Please enter your booking reference and review the booking information below.",
    "alert_please_note": "Please note:",
    "alert_different_rate_may_be_applicable": "A different rate may be applicable based on the Shipped on Board (B/L) date of your shipment.",
    "lbl_reference_for_this_booking": "Reference for this booking",
    "ph_for_example": "For example: PO:00001",
    "txt_booking_reference": "Booking reference",
    "txt_purchase_references_helper": "Separate multiple references with a comma, space, or enter",
    "txt_purchase_reference_already_added": "'{{reference}}' has already been added",
    "alert_different_cotnract_rate_may_be_applicable": "A different contract/rate may be applicable based on the Shipped on Board (B/L) date of your shipment",
    "txt_quote_for": "Quote for {{client_name}}: {{allInPrice}}",
    "txt_we_have_copied_attachments_for_you": "We have copied {{amount}} {{attachments}} for you",
    "txt_the_following_attachmetns_will_be_copied_from_your_request": "The following attachments will be copied from your request to the booking",
    "txt_click_here_to_select_doucments": "Click here to select documents",
    "txt_or_drag_file_here_to_upload": "or drag a file here to upload",
    "lbl_maximum_upload_file_size": "Maximum upload file size: 10MB",
    "lbl_i_accept_the": "I accept the",
    "lbl_forwarders_conditions": "forwarders conditions",
    "lbl_and_the": "and the",
    "lbl_general_conditions": "general conditions",
    "lbl_on_behalf_of": "on behalf of {{client_name}}",
    "lbl_you_must_accept_the_conditions_before_submitting": "You must accept the conditions before submitting this booking.",
    "txt_booking_organization": "Booking organization",
    "txt_you_need_to_accept_the_conditions": "You need to accept the conditions.",
    "txt_per_piece": "per piece",
    "lbl_container_type": "Container type",
    "txt_client_reference_has_a_maximum_of_35_characters": "Client reference has a maximum of 35 characters",
    "txt_you_must_accept_the_terms_and_conditions": "You must accept the terms and conditions",
    "txt_option": "option",
    "txt_options": "options",
    "txt_pc": "pc.",
    "txt_product_ready_date_cannot_be_more_than_1_year_in_the_past": "Product ready date cannot be more than 1 year in the past",
    "txt_product_ready_date_cannot_be_more_than_5_years_in_the_future": "Product ready date cannot be more than 5 years in the future",
    "txt_product_ready_date_must_be_within_1_year_in_the_past_and_5_years_in_the_future": "Product ready date must be within 1 year in the past and 5 years in the future",
    "txt_please_use_a_valid_date_in_format": "Please use a valid date in format dd-mm-yyyy",
    "cta_view_details": "View Details",
    "cta_add_more_details": "+ Add More Details",
    "txt_incoterm_colon": "Incoterm:",
    "txt_no_cargo_added_yet": "No cargo added yet",
    "txt_no_price_yet": "No price yet",
    "txt_no_carrier_found": "No carrier found",
    "txt_containers": "containers",
    "txt_container": "container",
    "txt_cargo": "cargo",
    "txt_transit_time": "Transit time",
    "txt_no_carrier_specific": "No carrier specific",
    "txt_cargo_information_will_be_added": "Cargo information will be added in next step",
    "alert_provide_additional_information": "Please provide additional information"
  },
  "address_fields": {
    "lbl_name": "Name",
    "lbl_street_address_1": "Street address 1",
    "lbl_street_address_2": "Street address 2",
    "lbl_country": "Country",
    "lbl_postal_code": "Postal code",
    "lbl_city": "City",
    "lbl_email": "Email",
    "lbl_phone": "Phone",
    "txt_no_addresses_found": "No addresses found",
    "txt_search_contacts": "Search contacts",
    "txt_company": "COMPANY",
    "txt_company_edited": "company edited",
    "txt_from_addressbook": "from addressbook",
    "txt_no_companies_found": "No companies found",
    "txt_contact": "CONTACT",
    "cta_add_new": "Add New",
    "txt_contact_edited": "contact edited",
    "txt_new_contact": "new contact",
    "lbl_cotnact_without_name_and_email": "Contact without name and email",
    "txt_no_contacts_found": "No contacts found",
    "txt_country_field_needs_update": "The country field in this address needs to be updated. Please choose a country from the list.",
    "txt_loading_address_book": "Loading address book",
    "lbl_netherlands": "Netherlands",
    "lbl_belgium": "Belgium",
    "lbl_germany": "Germany"
  },
  "cargo": {
    "lbl_weight_calculation_method": "Weight calculation method",
    "txt_weight_per_piece": "Weight per piece *",
    "txt_total_weight": "Total weight *",
    "txt_length_per_piece": "Length per piece *",
    "txt_width_per_piece": "Width per piece *",
    "txt_height_per_piece": "Height per piece *",
    "txt_volume_per_piece": "Volume {{data}}",
    "txt_per_piece": " per piece",
    "txt_dangerous_goods": " Dangerous goods",
    "txt_total": "total",
    "cta_add_package": "Add package",
    "txt_goods_description": "Goods description *",
    "txt_remarks": "Remarks",
    "txt_product_ready_date": "Product ready date"
  },
  "booking_details": {
    "txt_air_freight": "Air freight",
    "txt_ocean_freight": "Ocean freight",
    "txt_you_have_requested_this_booking_on": "You have requested this booking on {{date}}.",
    "txt_your_shipment_is_available": "Your shipment is available:",
    "lbl_origin": "Origin",
    "lbl_destination": "Destination",
    "lbl_shipper": "Shipper",
    "txt_weight_per_piece": "Weight per piece",
    "txt_total_weight": "Total weight",
    "txt_dimensions_per_piece": "Dimensions per piece",
    "txt_volume_per_piece": "Volume per piece",
    "txt_dangerous_goods": "Dangerous goods",
    "txt_no": "No",
    "txt_additional_information": "Additional information",
    "txt_consignee": "Consignee",
    "txt_new_booking_cargo": "New booking: Cargo",
    "cta_delete_container": "Delete container",
    "cta_add_another_container": "Add another container",
    "txt_shipper_and_cargo_details": "Shipper & cargo details",
    "lbl_quick_select": "Quick select:",
    "txt_no_contact_person": "No contact person",
    "txt_per_piece": "per piece",
    "cta_delete_package": "Delete package",
    "cta_add_another_package": "Add another package",
    "ph_briefly_describe_your_shipment": "Briefly describe the contents of your shipment",
    "lbl_additional_information": "Additional information",
    "ph_entry_any_additional_information": "Please enter any additional information that might be helpful",
    "cta_delete_shipper": "Delete shipper",
    "cta_add_another_shipper": "Add another shipper",
    "txt_pc": "pc."
  },
  "rotra_select": {
    "txt_select_an_option": "Select an option",
    "txt_disabled_because_the_form_is_read_only": "Disabled because the form is read-only",
    "txt_quick_select": "Quick Select"
  },
  "booking_step_general": {
    "txt_new_booking_general": "New booking: General",
    "txt_general_information": "General information",
    "alert_change_the_organization": "If you change the <strong>organization</strong>, your selected shipper and consignee addresses, as well as any uploaded attachments, will be reset.",
    "txt_active_organizations": "Active organizations",
    "txt_obsolete_organizations": "Obsolete organizations",
    "lbl_origin": "Origin",
    "lbl_destination": "Destiantion",
    "txt_only_file_names_without_special_characters": "Only file names without special characters (Examples: example.pdf, example101.pdf and example_101.pdf) are supported by myRotra.\nPlease change the file name of your upload in order to continue your booking."
  },
  "booking_step": {
    "txt_new_booking": "New booking",
    "lbl_i_accept_the_description": "I accept the {{description}}",
    "cta_download": "Download",
    "cta_previous": "Previous",
    "txt_loading": "Loading",
    "txt_sending_booking": "Sending booking... ",
    "cta_submit_booking": "Submit booking"
  },
  "booking_step_consignee": {
    "lbl_consignee": "Consignee",
    "txt_new_booking_consignee": "New booking: Consignee",
    "lbl_quick_select": "Quick select:",
    "txt_no_contact_person": "No contact person"
  },
  "booking_step_review": {
    "txt_new_booking_review": "New booking: Review",
    "txt_almost_here": "ALmost here ...",
    "txt_please_verify_your_booking_information_below": "  Please verify your booking information below. Click one of the edit buttons if you need to correct anything, or use the submit button at the top or bottom of this page to submit your booking.",
    "lbl_accept_the_description": "I accept the {{description}}",
    "txt_loading": "Loading",
    "txt_sending_booking": "Sending booking... ",
    "cta_submit_booking": "Submit booking"
  },
  "booking_page": {
    "txt_thank_you_for_placing_booking": "Thank you for placing a booking request with us! Shipping details follow once your booking is confirmed by our operations.",
    "txt_transport_unknown": "Transport unknown",
    "cta_quote_booking": "Qutoe booking",
    "txt_default_booking": "Default booking",
    "txt_would_you_like_to_resume_your_booking": "Would you like to resume your Booking where you left off?",
    "cta_no_start_new": "No, start new",
    "cta_yes_resume": "Yes, resume",
    "txt_new_booking": "New booking",
    "txt_we_have_completed_most_fields": "We have completed most fields for you based on your quotation.",
    "txt_please_verify_that_everything_is_as_expected": "Please verify that everything is as expected, and complete the fields in the highlighted blocks where needed.",
    "txt_information_left_for_you_to_complete": "Information left for you to complete: your reference (optional), attachments (optional), cargo & shipper information (required), consignee information (required)."
  },
  "non_conformities": {
    "txt_click_to_view_non_conformities": "Click to view non-conformities",
    "cta_submit_report": "Submit Report",
    "txt_all_non_conformities_related_to_this_shipment_are_listed_below": "All Non-Conformities related to this shipment are listed below. Check the details of each report to track progress and status.",
    "txt_document_and_track_quality_issues_related_to_this_shipment": "Document and track quality issues related to this shipment. Please select the type of issue and provide a clear description so we can take appropriate action promptly.",
    "txt_view_detailed_information_about_this_non_conformity": "View detailed information about this non-conformity, including its status, description, and any actions taken. Use the back button to return to the list of non-conformities.",
    "txt_report_non_conformity": "Report Non-Conformity",
    "txt_non_conformities_amount": "Non-Conformities ({{amount}})",
    "txt_basic_information": "Basic information",
    "txt_date": "Date",
    "txt_non_conformity_type": "Non-Conformity Type",
    "txt_sales_or_quote": "Sales or Quote",
    "txt_delay": "Delay(s)",
    "txt_damage_missing": "Damage/Missing",
    "txt_financial": "Financial",
    "txt_operational": "Operational",
    "txt_details": "Details",
    "lbl_description": "Description",
    "ph_enter_description_here": "Enter description here...",
    "lbl_non_conformity_date": "Non-Conformity date",
    "lbl_type": "Type",
    "lbl_filed_by": "Filed by",
    "txt_by_on_date": "{{name}} on {{date}}",
    "lbl_action": "Action",
    "txt_handled_by_on": "Handled by {{name}} on {{date}}",
    "alert_no_action_has_been_taken_yet": "No action has been taken yet.",
    "cta_file_non_conformity": "File Non Conformity",
    "txt_no_non_conformity_reports_found": "No non-conformity reports found.",
    "txt_filed_by_on": "Filed by: {{name}} on {{date}}",
    "lbl_status_open": "Open",
    "lbl_status_in_progress": "In Progress",
    "lbl_status_resolved": "Resolved",
    "lbl_status_default": "Unknown Status",
    "lbl_damage_missing": "Damage / Missing",
    "lbl_delay": "Delay(s)",
    "type_financial": "Financial",
    "lbl_sales_quote": "Sales / Quote",
    "lbl_operational": "Operational",
    "lbl_default": "Unknown Type",
    "txt_non_conformity_reprot_has_been_submitted": "The non-conformity report has been submitted"
  },
  "intro_user": {
    "txt_welcome_to_myrotra": "Welcome to myRotra",
    "txt_you_have_successfully_created_your_account": "You have successfully created your account",
    "cta_track_your_shipments": "Track your Shipments",
    "cta_go_directly_to_your_shipments": "Go directly to your Shipments and start tracking them on myRotra",
    "cta_go_to_dashboard": "Go to Dashboard",
    "txt_how_would_you_like_to_proceed": "How would you like to proceed?",
    "cta_request_your_first_quote": "Request your first quote",
    "txt_congratulations": "Congratulations!"
  },
  "error_user": {
    "txt_something_went_wrong": "Something went wrong",
    "txt_something_went_wrong_error_text": "Someting went wrong...",
    "cta_go_to_main_page": "go to main page",
    "txt_unexpected_error_occurred_while_attemppting_to_perform_requested_operation": "An unexpected error occurred while attempting to perform the requested operation. We apologize for any inconvenience this may have caused. Please try again later or contact us using the support tool."
  },
  "authenticated_user": {
    "txt_already_logged_in": "Already logged in...",
    "cta_continue_to_myrotra": "Continue to myRotra",
    "cta_sign_out": "Sign Out",
    "txt_you_are_already_signed_in": "You are already signed in",
    "txt_you_cannot_sing_up_while_logged_in": "You cannot sign up again while logged in. If you want to create a new account, you first need to sign out. Alternatively, you can continue using myRotra."
  },
  "submitting_user": {
    "txt_activating_account": "Activating account",
    "txt_signing_you_in": "Signing you in",
    "txt_something_went_wrong": "Something went wrong",
    "txt_something_went_wrong_error_text": "Something went wrong...",
    "cta_go_to_main_page": "Go to main page",
    "txt_something_unexpected_happend_while_activation_your_account": "Something unexpected happened while activating your account. We apologize for any inconvenience this may have caused. Please try again later or contact us using the support tool.",
    "txt_an_unexpected_error_occurred_while_signing_you_in": "An unexpected error occurred while signing you in. Please continue to the sign-in page to continue using myRotra."
  },
  "activate_user": {
    "cta_complete": "Complete",
    "txt_welcome_to_myrotra": "Welcome to myRotra!",
    "txt_just_few_simple_steps": "We're thrilled to have you here! In just a few simple steps, you'll be all set up and ready to dive into an awesome experience. Let's go!",
    "txt_continue_to_the_next_step_to_get_started": "Continue to the next step to get started, and create an account for:",
    "txt_already_have_an_account": "Already have an account?",
    "cta_sign_in_here": "Sign in here",
    "txt_who_are_you": "Who are you?",
    "txt_please_tell_us_about_yourself": "Tell us a little about yourself so we can tailor your experience. This helps us provide the best possible service for you.",
    "ph_first_name": "First name",
    "lbl_first_name": "First name",
    "ph_last_name": "Last name",
    "lbl_last_name": "Last name",
    "txt_secure_your_account": "Secure your account",
    "txt_protect_your_account_by_creating_a_strong_and_secure_password": "Protect your account by creating a strong and secure password. This keeps your information safe and ensures only you have access.",
    "lbl_password": "Password",
    "txt_password_requirements": "Your password must contain:",
    "txt_terms_of_use": "Terms of Use",
    "lbl_i_agree_to_the_terms_of_use": "I agree to the Terms of Use",
    "lbl_at_least_8_characters": "At least 8 characters",
    "lbl_at_least_one_lower_and_uppercase": "At least one lowercase and uppercase letter",
    "lbl_at_least_one_number": "At least one number",
    "lbl_at_least_one_special_character": "At least one special (!@#$%^&*) character"
  },
  "calendar": {
    "txt_calendar": "Calendar",
    "txt_purchase_references": "Purchase References",
    "txt_you_have_no_upcoming_activities": "You don't have any upcoming activities",
    "txt_later": "later",
    "txt_earlier": "earlier"
  },
  "navigation_guide": {
    "txt_finish_tour": "Finish the tour",
    "txt_skip_tour": "Skip the tour",
    "txt_address_book_step_1": "The address book is used to store your contacts, grouped by company. The address book is filled automatically when you enter shipper- and consignee information during the booking process of myRotra.",
    "txt_address_book_step_2": "You can search by company name and contact name.",
    "txt_address_book_step_3": "Optionally, you can manually pre-fill the address book with contacts if you already know you want to re-use certain contacts often during the booking process.",
    "txt_bookings_step_1": "This page shows you the bookings overview.",
    "txt_bookings_step_2": "You can search bookings using keywords.",
    "txt_bookings_step_3": "You can filter air/ocean freight and status.",
    "txt_bookings_step_4": "You can add new bookings using this button.",
    "txt_booking_widget_step_1": "Welcome to the Booking widget. This widget assists you in submitting a booking from a contract.",
    "txt_booking_widget_step_2": "This region of the Booking widget shows your progress and the required steps to submit a booking.",
    "txt_booking_widget_step_3": "This region of the Booking widget shows your progress and the required steps to submit a booking.",
    "txt_booking_widget_step_4": "This region of the Booking widget assists you in navigating to the next or previous step.",
    "txt_booking_widget_step_5": "You can go to the next page once the mandatory fields are filled in.",
    "txt_contracts_step_1": "This page shows an overview of your contracts.",
    "txt_contracts_step_2": "You can filter contracts on status.",
    "txt_contracts_step_3": "This is a summary of your contract. This summary shows the contract details such as the modality, your reference, the incoterm, the routing, and the expiration date.",
    "txt_contracts_step_4": "You can book a contract by clicking on the book button.",
    "txt_navigation_step_1": "Welcome to myRotra! Click \"next\" if you would like a short guided tour of the system, or click \"skip\" if you just want to get started using the system directly.",
    "txt_navigation_step_2": "System notifications will appear here. They will inform you of events related to bookings and shipments. When we release a new version of the system, you will also receive a notification with an overview of the changes.",
    "txt_navigation_step_3": "Navigation related to your user profile can be opened by clicking the avatar, for example if you want to change your password or log out.",
    "txt_navigation_step_4": "The main navigation contains all available functionality of myRotra. When you first visit any of these pages, you will receive a page-specific tour.",
    "txt_shipments_step_1": "This page shows you the shipments overview.",
    "txt_shipments_step_2": "You can search shipments using keywords.",
    "txt_shipments_step_3": "You can filter air/ocean freight, import/export, status, and you can change the sorting setting."
  }
}
